// AUTO-GENERATED by scripts/generate-locales.ts. Do not edit directly.

export type Locale = "ar" | "en" | "es" | "et" | "kab"

export const SOURCE_LOCALE: Locale = "en"

export const SUPPORTED_LOCALES: readonly Locale[] = [
  "ar",
  "en",
  "es",
  "et",
  "kab",
] as const

export const NATIVE_NAMES: Readonly<Record<Locale, string>> = {
  "ar": "العربية",
  "en": "English",
  "es": "Español",
  "et": "Eesti",
  "kab": "Taqbaylit",
}

/**
 * Per-locale translation coverage (fraction of source keys
 * translated, 0..1). Source locale is always 1.0. Computed at
 * codegen time; gate for the public picker is 0.8.
 */
export const LOCALE_COVERAGE: Readonly<Record<Locale, number>> = {
  "ar": 0.0000,
  "en": 1.0000,
  "es": 0.1637,
  "et": 0.0018,
  "kab": 0.0045,
}

/**
 * Subset of SUPPORTED_LOCALES that meets the picker visibility
 * threshold (`coverage >= 0.8`). Below-threshold locales stay
 * reachable via `?lang=<code>` for testing; they only disappear
 * from the public language picker. Source locale is always
 * included regardless of coverage.
 */
export const PICKER_LOCALES: readonly Locale[] = [
  "en",
] as const

/** English source bundle — always available synchronously. */
const enLiteral = {
  "analyze.close": "Close analysis",
  "analyze.contour.clear": "Clear outline",
  "analyze.contour.draw": "Outline on globe",
  "analyze.contour.levelRow": "{level} — {km2} km² above",
  "analyze.contour.noLevels": "No round value falls inside the range the colour bar is isolating. Widen the threshold to get contour lines.",
  "analyze.contour.rangeCaption": "{count} lines across the full range, at the same values the colour bar labels.",
  "analyze.contour.scopedCaption": "{count} lines inside the range the colour bar is isolating, at the same values it labels.",
  "analyze.contour.staleCleared": "The globe moved to another frame, so the outline was removed rather than left describing data it was not measured from. Draw it again for the frame showing now.",
  "analyze.contour.staleNote": "Drawn from the colour bar as it was when you pressed the button. Move it and outline again to follow it.",
  "analyze.contour.title": "Where the line falls",
  "analyze.contour.unwatched": "This outline is pinned to one frame and can't tell when the globe moves on, so it won't clear itself. Draw it again after seeking.",
  "analyze.coverage": "{percent}% of this region has data ({count} grid cells).",
  "analyze.empty.noDataset": "Load a dataset that carries values to analyze it. Older datasets are pictures, so there are no numbers to measure.",
  "analyze.empty.noValues": "No data in this region.",
  "analyze.empty.outsideDataset": "This region falls outside the dataset's coverage.",
  "analyze.empty.unavailable": "Analysis isn't available right now.",
  "analyze.empty.unknownRegion": "That region couldn't be located, so there's nothing to measure.",
  "analyze.export": "Export CSV",
  "analyze.frameTime": "Measured on the frame showing {time}.",
  "analyze.histogram.aria": "Distribution of values, coloured by the map's own palette",
  "analyze.histogram.caption": "Each bar covers about {width}.",
  "analyze.precision": "Values are resolved to about {step}; treat smaller differences as noise.",
  "analyze.scope.dataset": "Whole dataset",
  "analyze.scope.label": "Region",
  "analyze.scope.view": "What I can see",
  "analyze.stat.area": "Area with data",
  "analyze.stat.max": "Highest",
  "analyze.stat.mean": "Mean",
  "analyze.stat.median": "Median",
  "analyze.stat.min": "Lowest",
  "analyze.stat.none": "—",
  "analyze.stat.p10": "10th percentile",
  "analyze.stat.p90": "90th percentile",
  "analyze.stat.stdDev": "Spread",
  "analyze.title": "Analyze",
  "analyze.transect.aria": "Value along the line, from one end to the other",
  "analyze.transect.cancel": "Cancel",
  "analyze.transect.caption": "Height is scaled to this line's own range.",
  "analyze.transect.clear": "Clear",
  "analyze.transect.coverage": "{withData} of {samples} points along the line have data, one every {spacing}.",
  "analyze.transect.draw": "Draw a line",
  "analyze.transect.export": "Export line as CSV",
  "analyze.transect.hint": "Draw a line across the globe to see how the values change along it.",
  "analyze.transect.noData": "This line doesn't cross any data.",
  "analyze.transect.pickFirst": "Click where the line should start.",
  "analyze.transect.pickSecond": "Now click where it should end.",
  "analyze.transect.stat.length": "Length",
  "analyze.transect.title": "Along a line",
  "analyze.units.km": "km",
  "analyze.units.km2": "km²",
  "analyze.zonal.aria": "Average value at each latitude, coloured by the map's own palette",
  "analyze.zonal.caption": "North is at the top. Width is scaled to this profile's own range.",
  "analyze.zonal.coverage": "{withData} of {rows} latitude bands have data.",
  "analyze.zonal.export": "Export profile as CSV",
  "analyze.zonal.narrow": "This region covers too few latitude bands to show a profile.",
  "analyze.zonal.stat.peak": "Highest band",
  "analyze.zonal.stat.peakValue": "Average there",
  "analyze.zonal.title": "By latitude",
  "app.globe.aria": "Globe visualization",
  "app.skipLink": "Skip to globe visualization",
  "app.title": "Terraviz",
  "blog.public.cardMeta": "{date} · {count} datasets to explore",
  "blog.public.citation": "Prompted by:",
  "blog.public.empty": "No posts yet — check back soon.",
  "blog.public.explore": "Explore the data",
  "blog.public.indexLink": "Blog",
  "blog.public.loading": "Loading…",
  "blog.public.missing.back": "Back to all posts",
  "blog.public.missing.title": "That post isn't here.",
  "blog.public.playTour": "▶ Play the companion tour",
  "blog.public.title": "From the team",
  "browse.activeFilters.aria": "Active filters",
  "browse.activeFilters.bbox.region": "Region {ns}, {ew}",
  "browse.activeFilters.range.dataCoverage": "Coverage {start}–{end}",
  "browse.activeFilters.range.dateAdded": "Added {start}–{end}",
  "browse.activeFilters.remove.aria": "Remove filter: {label}",
  "browse.announce.closed": "Dataset browser closed",
  "browse.askOrbit.aria": "Open Orbit, your digital docent",
  "browse.askOrbit.title": "Ask Orbit",
  "browse.card.catalogLink": "View in SOS catalog ↗",
  "browse.card.keyword.aria": "Filter by {keyword}",
  "browse.card.load": "Load",
  "browse.card.load.aria": "Load {title}",
  "browse.card.meta.added": "Added:",
  "browse.card.meta.datasetDeveloper": "Dataset developer:",
  "browse.card.meta.source": "Source:",
  "browse.card.meta.timeRange": "Time range:",
  "browse.card.meta.visualization": "Visualization:",
  "browse.card.scrubber.afterEnd": "now is after the series",
  "browse.card.scrubber.aria": "Frame timeline: {count} frames from {start} to {end}",
  "browse.card.scrubber.beforeStart": "now is before the series",
  "browse.card.scrubber.frames": "{count} frames",
  "browse.card.scrubber.framesOnly": "{count} frames",
  "browse.card.scrubber.now": "now",
  "browse.card.thumb.alt": "{title} thumbnail",
  "browse.category.all": "All",
  "browse.close.aria": "Close dataset browser",
  "browse.continue.aria": "Continue exploring",
  "browse.continue.heading": "Continue exploring",
  "browse.count.one": "1 dataset",
  "browse.count.other": "{count} datasets",
  "browse.docentHint": "Not sure what you need? Ask Orbit →",
  "browse.download.aria": "Download {title} for offline use",
  "browse.download.downloaded.title": "Downloaded ({size})",
  "browse.download.downloading.title": "Downloading…",
  "browse.download.title": "Download for offline use",
  "browse.filter.clearAll": "Clear filters",
  "browse.filter.clearAll.aria": "Clear all filters",
  "browse.filter.dataCoverage.fromLabel": "From year",
  "browse.filter.dataCoverage.label": "Data coverage",
  "browse.filter.dataCoverage.toLabel": "To year",
  "browse.filter.dateAdded.fromLabel": "From year",
  "browse.filter.dateAdded.label": "Date added",
  "browse.filter.dateAdded.toLabel": "To year",
  "browse.filter.format.aria": "Filter by format",
  "browse.filter.format.image": "Image",
  "browse.filter.format.label": "Format",
  "browse.filter.format.other": "Other",
  "browse.filter.format.tour": "Tour",
  "browse.filter.format.video": "Video",
  "browse.filter.group.category": "Category & content",
  "browse.filter.group.format": "Format & medium",
  "browse.filter.group.quality": "Quality & availability",
  "browse.filter.group.time": "Time",
  "browse.filter.hasCaptions.label": "Has closed captions",
  "browse.filter.hasTour.label": "Has guided tour",
  "browse.filter.includeSos.help": "Include lower-fidelity preview-quality datasets from the broader SOS catalog ({count} more).",
  "browse.filter.includeSos.label": "Include all SOS datasets",
  "browse.filter.rail.aria": "Filter datasets",
  "browse.filter.recentlyViewed.help": "Show only datasets you've opened before.",
  "browse.filter.recentlyViewed.label": "Recently viewed",
  "browse.filter.tags.aria": "Filter by category",
  "browse.filter.tags.label": "Category",
  "browse.filters.toggle.aria": "Show or hide the filter panel",
  "browse.filters.toggle.label": "Filters",
  "browse.graph.empty": "No datasets match the current filters — adjust the chip rail to see the graph.",
  "browse.graph.legend.category": "Category",
  "browse.graph.legend.dataset": "Dataset",
  "browse.graph.legend.format": "Format",
  "browse.graph.legend.keyword": "Keyword",
  "browse.graph.loadError": "Could not load the graph view.",
  "browse.graph.loading": "Loading graph view…",
  "browse.graph.recenter": "Recenter",
  "browse.graph.recenter.aria": "Recenter the graph view",
  "browse.graph.region.aria": "Catalog graph view — {count} datasets, {edgeCount} connections",
  "browse.graph.showFormat.aria": "Show format-bucket nodes in the graph",
  "browse.graph.showFormat.label": "Show formats",
  "browse.graph.tooltip.coOccurrence": "Top co-occurring: {neighbours}",
  "browse.graph.tooltip.viewDetails": "Click to view details",
  "browse.hero.dismiss.aria": "Dismiss",
  "browse.hero.heading": "Right now",
  "browse.hero.label": "Happening now",
  "browse.hero.via": "via",
  "browse.map.banner.allGlobal.one": "1 dataset shown — it covers the entire globe. Most SOS datasets are worldwide today; regional bounding boxes will appear as distinct rectangles as publishers add them.",
  "browse.map.banner.allGlobal.other": "{count} datasets shown — all cover the entire globe. Most SOS datasets are worldwide today; regional bounding boxes will appear as distinct rectangles as publishers add them.",
  "browse.map.clearRegion.aria": "Clear the drawn region filter",
  "browse.map.clearRegion.label": "Clear region",
  "browse.map.draw.aria": "Toggle draw-rectangle mode — drag to filter datasets by geographic region",
  "browse.map.draw.label": "Draw region",
  "browse.map.empty": "No datasets match the current filters — adjust the chip rail to see the map.",
  "browse.map.empty.allGlobalHidden": "All matching datasets are global — toggle Include global to surface them.",
  "browse.map.empty.allUndated": "None of the matching datasets carry geographic coverage — switch to Cards to see them.",
  "browse.map.event.tooltip.source": "Source: {name}",
  "browse.map.hiddenGlobalFootnote.one": "1 global dataset hidden — toggle “Include global” to surface it.",
  "browse.map.hiddenGlobalFootnote.other": "{count} global datasets hidden — toggle “Include global” to surface them.",
  "browse.map.includeGlobal.label": "Include global",
  "browse.map.legend.coverage": "Coverage",
  "browse.map.legend.event": "Current event",
  "browse.map.legend.realtime": "Real-time",
  "browse.map.loadError": "Could not load the map view.",
  "browse.map.loading": "Loading map view…",
  "browse.map.region.aria": "Catalog map view — {count} datasets with geographic coverage",
  "browse.map.tooltip.more": "+{count} more",
  "browse.map.tooltip.realtime": "real-time",
  "browse.map.undatedFootnote.one": "1 dataset has no geographic coverage — switch to Cards to see it.",
  "browse.map.undatedFootnote.other": "{count} datasets have no geographic coverage — switch to Cards to see them.",
  "browse.newSince.badge": "{count} new since your last visit",
  "browse.noResults": "No datasets match your search.",
  "browse.overlay.aria": "Dataset browser",
  "browse.search.clear.aria": "Clear search",
  "browse.search.label": "Search datasets",
  "browse.search.placeholder": "Search datasets…",
  "browse.search.placeholderCount": "Search {count} datasets…",
  "browse.sort.aria": "Sort datasets",
  "browse.sort.az": "A–Z",
  "browse.sort.newest": "Newest",
  "browse.sort.relevance": "Relevance",
  "browse.subtitle": "Browse environmental datasets from NOAA Science On a Sphere",
  "browse.timeline.brush.aria": "Drag on the time axis to filter datasets by coverage range",
  "browse.timeline.brush.clear": "Clear range",
  "browse.timeline.brush.clear.aria": "Clear the brushed time range filter",
  "browse.timeline.brush.hint": "↔ Drag to filter by year",
  "browse.timeline.brush.summary": "Range: {start} – {end}",
  "browse.timeline.empty": "No datasets with temporal coverage match the current filters — adjust the chip rail to see the timeline.",
  "browse.timeline.event.aria": "Current event: {title} — open the related dataset",
  "browse.timeline.events.aria": "Current events on the timeline",
  "browse.timeline.legend.coverage": "Coverage",
  "browse.timeline.legend.event": "Current event",
  "browse.timeline.legend.realtime": "Real-time",
  "browse.timeline.loadError": "Could not load the timeline view.",
  "browse.timeline.loading": "Loading timeline view…",
  "browse.timeline.region.aria": "Catalog timeline view — {count} datasets sorted by start year",
  "browse.timeline.row.aria": "{title} — coverage {start} to {end}",
  "browse.timeline.undatedFootnote.one": "1 dataset has no temporal coverage — switch to Cards to see it.",
  "browse.timeline.undatedFootnote.other": "{count} datasets have no temporal coverage — switch to Cards to see them.",
  "browse.viewMode.aria": "Switch between card grid, graph, timeline, and map views",
  "browse.viewMode.cards": "Cards",
  "browse.viewMode.cards.aria": "Show datasets as a card grid",
  "browse.viewMode.graph": "Graph",
  "browse.viewMode.graph.aria": "Show datasets as a network graph",
  "browse.viewMode.map": "Map",
  "browse.viewMode.map.aria": "Show datasets as bounding-box overlays on a flat world map",
  "browse.viewMode.timeline": "Timeline",
  "browse.viewMode.timeline.aria": "Show datasets as a horizontal timeline",
  "catalogTabs.aria": "Switch between catalog and sphere view",
  "catalogTabs.catalog": "Catalog",
  "catalogTabs.sphere": "Sphere",
  "chat.action.analyze.aria": "Open the Analyze panel for {region}",
  "chat.action.analyzeDataset": "Open in Analyze",
  "chat.action.analyzeRegion": "Analyze {region}",
  "chat.action.analyzeView": "Analyze this view",
  "chat.action.compareInBrowse": "Compare these side by side in Browse →",
  "chat.action.flyingTo": "Flying to {coords}",
  "chat.action.highlighted": "Highlighted {label}",
  "chat.action.labelsHidden": "Labels hidden",
  "chat.action.labelsShown": "Labels shown",
  "chat.action.load": "Load ➤",
  "chat.action.load.aria": "Load {title}",
  "chat.action.loadFrame": "Load frame ➤",
  "chat.action.loadFrame.aria": "Load frame {name}",
  "chat.action.loaded": "Loaded ✔",
  "chat.action.loadsLabel": "→ Loads: **{title}**",
  "chat.action.marker": "Marker: {label}",
  "chat.action.navigatingTo": "Navigating to {label}",
  "chat.action.regionDefault": "region",
  "chat.action.seekingTo": "Seeking to {date}",
  "chat.announce.cleared": "Chat cleared",
  "chat.announce.closed": "Chat closed",
  "chat.announce.docentResponded": "Docent responded",
  "chat.announce.feedbackExtra": "Additional feedback submitted",
  "chat.announce.feedbackFailed": "Feedback failed — please try again",
  "chat.announce.feedbackSubmitted": "Feedback submitted",
  "chat.announce.loading": "Loading dataset",
  "chat.announce.loadingFrame": "Loading frame",
  "chat.announce.opened": "Chat opened",
  "chat.announce.settingsSaved": "Settings saved",
  "chat.announce.testFailed": "LLM connection failed",
  "chat.announce.testSuccess": "LLM connection successful",
  "chat.announce.visionDisabled": "Vision mode disabled",
  "chat.announce.visionEnabled": "Vision mode enabled",
  "chat.announce.voiceError": "Voice input is unavailable",
  "chat.announce.voiceListening": "Listening",
  "chat.announce.voiceMuted": "Microphone muted",
  "chat.announce.voiceStopped": "Stopped speaking",
  "chat.announce.withdrawn": "Orbit has been turned off on this site",
  "chat.autoLoad.altHint": " Here are some alternatives if this isn't quite right:",
  "chat.autoLoad.message": "I've loaded **{title}** — that's your closest match.{altHint}",
  "chat.clear.aria": "Clear chat history",
  "chat.clear.title": "Clear chat",
  "chat.close.aria": "Close chat",
  "chat.close.title": "Close chat",
  "chat.datasetPrompt.cta": "Ask the Docent about {title} →",
  "chat.datasetPrompt.tellMe": "Tell me about {title}",
  "chat.degraded.quotaExhausted": "Reduced functionality — Workers AI quota reached. Suggestions are using offline matching until it recovers.",
  "chat.error.generic": "Sorry, I had trouble responding. Try asking again, or check the LLM settings.",
  "chat.event.eyebrow": "In the news",
  "chat.fallback.localDev": "⚠ AI service unavailable — running in offline mode. Make sure `npm run dev` is proxying /api, or configure a local provider in settings.",
  "chat.fallback.production": "⚠ AI service unavailable — showing offline results. Check LLM settings.",
  "chat.feedback.dismiss": "Dismiss",
  "chat.feedback.placeholder.negative": "What could be improved? (optional)",
  "chat.feedback.placeholder.positive": "What was helpful? (optional)",
  "chat.feedback.send": "Send",
  "chat.feedback.sheetAria": "Additional feedback",
  "chat.feedback.tag.clearExplanation": "Clear explanation",
  "chat.feedback.tag.goodLevelOfDetail": "Good level of detail",
  "chat.feedback.tag.greatRecommendation": "Great recommendation",
  "chat.feedback.tag.helpedMeExplore": "Helped me explore",
  "chat.feedback.tag.inaccurateInfo": "Inaccurate info",
  "chat.feedback.tag.learnedSomething": "Learned something new",
  "chat.feedback.tag.misunderstood": "Didn't understand my question",
  "chat.feedback.tag.offTopic": "Off topic",
  "chat.feedback.tag.tooLong": "Too long",
  "chat.feedback.tag.wrongDataset": "Wrong dataset",
  "chat.feedback.thumbsDown": "Bad response",
  "chat.feedback.thumbsUp": "Good response",
  "chat.header.subtitle": "· digital docent",
  "chat.header.title": "Orbit",
  "chat.input.label": "Ask Orbit",
  "chat.input.placeholder": "Ask about any dataset…",
  "chat.measurement.at": "{lat}, {lon}",
  "chat.measurement.eyebrow": "Measured",
  "chat.messages.aria": "Conversation",
  "chat.panel.aria": "Orbit — digital docent",
  "chat.send.aria": "Send message",
  "chat.settings.aria": "Chat settings",
  "chat.settings.debug.label": "Debug — show all log messages in browser console",
  "chat.settings.enabled.label": "Enable LLM (disable for local-only mode)",
  "chat.settings.key.label": "API Key (optional)",
  "chat.settings.key.placeholder": "Not needed for built-in AI",
  "chat.settings.key.tauri.placeholder": "Stored securely in OS keychain",
  "chat.settings.model.appleIntelligence": "Local (Apple Intelligence)",
  "chat.settings.model.aria": "Model",
  "chat.settings.model.label": "Model",
  "chat.settings.model.loading": "Loading models…",
  "chat.settings.model.noneFound": "No models found",
  "chat.settings.readingLevel.aria": "Reading level",
  "chat.settings.readingLevel.expert": "Expert",
  "chat.settings.readingLevel.general": "General",
  "chat.settings.readingLevel.inDepth": "In-Depth",
  "chat.settings.readingLevel.label": "Reading Level",
  "chat.settings.readingLevel.youngLearner": "Young Learner",
  "chat.settings.save": "Save",
  "chat.settings.status.connected": "Connected",
  "chat.settings.status.enableHint": "Connected — but \"Enable LLM\" is unchecked. Check it and Save to use AI.",
  "chat.settings.status.failedToConnect": "Failed to connect",
  "chat.settings.status.saved": "Saved",
  "chat.settings.status.testing": "Testing…",
  "chat.settings.test": "Test Connection",
  "chat.settings.title": "Settings",
  "chat.settings.url.label": "API URL",
  "chat.settings.url.placeholder": "/api (or http://localhost:11434/v1)",
  "chat.settings.url.tauri.placeholder": "https://api.openai.com/v1 or http://localhost:11434/v1",
  "chat.settings.vision.label": "Vision mode — send a globe screenshot with each message so Orbit can describe what you see. Uses a vision-capable model automatically.",
  "chat.settings.voiceAutoSpeak.label": "Speak replies aloud — Orbit reads its answers using your device's voice. Available in supported languages.",
  "chat.settings.voiceHandsFree.label": "Hands-free",
  "chat.settings.voiceHandsFree.off": "Off",
  "chat.settings.voiceHandsFree.openMic": "Open mic",
  "chat.settings.voiceHandsFree.pushToTalk": "Push to talk",
  "chat.settings.voiceHandsFree.wakeWord": "Wake word",
  "chat.settings.voiceLang.auto": "Same as app",
  "chat.settings.voiceLang.label": "Recognition language",
  "chat.settings.voiceName.default": "Default",
  "chat.settings.voiceName.label": "Voice",
  "chat.settings.voiceProvider.auto": "Automatic",
  "chat.settings.voiceProvider.browser": "Browser",
  "chat.settings.voiceProvider.cloud": "Cloud (Cloudflare)",
  "chat.settings.voiceProvider.label": "Voice engine",
  "chat.settings.voiceRate.fast": "Fast",
  "chat.settings.voiceRate.faster": "Faster",
  "chat.settings.voiceRate.label": "Speaking rate",
  "chat.settings.voiceRate.normal": "Normal",
  "chat.settings.voiceRate.slow": "Slow",
  "chat.trigger.aria": "Open digital docent chat",
  "chat.trigger.label": "Ask Orbit",
  "chat.trigger.title": "Ask the docent",
  "chat.vision.aria": "Toggle vision analysis",
  "chat.vision.title": "Vision: analyze globe screenshot",
  "chat.visionHint.body": " — Orbit can see the globe. A screenshot of the current view is sent with each message for visual analysis.",
  "chat.visionHint.label": "Vision on",
  "chat.voice.aria": "Voice input",
  "chat.voice.speakAria": "Read aloud",
  "chat.voice.stopAria": "Stop speaking",
  "chat.voice.title": "Speak to Orbit",
  "chat.voice.titleListening": "Stop listening",
  "chat.welcome.hint": "Browse the catalog to compare options side by side. Ask me when you have something specific in mind.",
  "chat.welcome.intro": "**I'm Orbit**, your digital docent — I help you find the right dataset for your question.",
  "chat.welcome.suggestions.arctic.label": "Arctic",
  "chat.welcome.suggestions.arctic.query": "Which datasets cover the Arctic?",
  "chat.welcome.suggestions.hurricanes.label": "Hurricanes",
  "chat.welcome.suggestions.hurricanes.query": "Show me something related to hurricanes",
  "chat.welcome.suggestions.ndvi.label": "What is NDVI?",
  "chat.welcome.suggestions.ndvi.query": "Explain what NDVI measures",
  "chat.welcome.suggestions.seaLevel.label": "Sea level rise",
  "chat.welcome.suggestions.seaLevel.query": "What datasets show sea level rise?",
  "colorbar.aria": "Colour scale from {min} to {max}",
  "colorbar.ariaAdjust": "{name}. Tap to adjust colours.",
  "colorbar.ariaWithTitle": "{title} colour scale, from {min} to {max}",
  "colorbar.controls.close": "Close colour controls",
  "colorbar.controls.title": "Colour & range",
  "colorbar.palette.grayscale": "Grayscale",
  "colorbar.palette.label": "Palette",
  "colorbar.palette.magma": "Magma",
  "colorbar.palette.source": "Original",
  "colorbar.palette.turbo": "Turbo",
  "colorbar.palette.viridis": "Viridis",
  "colorbar.range.label": "Range shown",
  "colorbar.range.max": "Range high end",
  "colorbar.range.min": "Range low end",
  "colorbar.range.readout": "{min} to {max}",
  "colorbar.reset": "Reset colours",
  "colorbar.tapToAdjust": "Tap to adjust colours",
  "colorbar.threshold.above": "Only {value} and above",
  "colorbar.threshold.below": "Only {value} and below",
  "colorbar.threshold.between": "Only {min} to {max}",
  "colorbar.threshold.keeps": "{band} — keeps {percent}% of the data",
  "colorbar.threshold.label": "Hide values",
  "colorbar.threshold.max": "Hide above",
  "colorbar.threshold.min": "Hide below",
  "colorbar.threshold.none": "Showing everything",
  "credits.aboutLink": "About TerraViz →",
  "credits.close.aria": "Close credits",
  "credits.desc": "Where the imagery and data on screen come from.",
  "credits.empty.basemap": "No basemap sources declared.",
  "credits.empty.dataset": "No dataset loaded.",
  "credits.section.basemap": "Basemap",
  "credits.section.loaded": "Loaded dataset",
  "credits.section.loadedPanel": "Loaded — Panel {n}",
  "credits.title": "Credits",
  "disclosureBanner.announce": "Privacy notice available. A shield button in the top-left opens the details.",
  "disclosureBanner.aria": "Privacy notice",
  "disclosureBanner.badge.aria": "Privacy notice — tap for details",
  "disclosureBanner.dismiss": "Got it",
  "disclosureBanner.dismiss.aria": "Dismiss privacy notice",
  "disclosureBanner.policy": "Read policy",
  "disclosureBanner.settings": "Privacy settings",
  "disclosureBanner.text": "This app reports anonymous usage events to help us keep it healthy. No account, no tracking cookies, no third-party analytics. You can change this any time.",
  "docent.category.list": "Here are some **{category}** datasets:",
  "docent.category.none": "I didn't find datasets in the \"{category}\" category. Try a different topic or search term.",
  "docent.describe.categories": "This is a {categories} dataset.",
  "docent.explain.categories": " It falls under: {categories}.",
  "docent.explain.noDataset": "You're looking at Earth with real-time cloud cover. Browse the datasets or ask me about a topic — I'll load something onto the globe for you.",
  "docent.explain.source": " Source: {source}.",
  "docent.explain.timeRange": " This data covers {start} through {end}.",
  "docent.greeting.1": "Welcome to Science on a Sphere! I'm Orbit, your digital docent — ask me about any topic and I'll find a dataset to show you. Try asking about oceans, climate, hurricanes, or anything else that interests you.",
  "docent.greeting.2": "Hello! I'm here to guide you through over 500 visualizations of our planet and beyond. What would you like to explore? You can ask about a topic, or I can tell you more about whatever's on the globe right now.",
  "docent.greeting.3": "Hi there! Think of me as your personal guide to Earth science data. Ask me about weather, the ocean floor, space, volcanoes — or just say \"show me something interesting\" and I'll pick something out.",
  "docent.help": "Here's how I can help:\n\n• **Ask about a topic** — \"Tell me about hurricanes\" or \"Show me ocean temperatures\"\n• **Explore categories** — \"Show me atmosphere datasets\" or \"What about space?\"\n• **Learn about what's showing** — \"Explain this\" or \"What am I looking at?\"\n• **Find related data** — \"Show me something similar\" or \"More like this\"\n• **Search freely** — Just type any question and I'll find relevant datasets",
  "docent.patterns.explain": "explain, explain this, explain it, tell me about this, tell me about it, tell me about the current, tell me about what's showing, tell me more about this, tell me more about it, describe this, describe it, describe the current, what does this show, what does this mean",
  "docent.patterns.greeting": "hi, hello, hey, howdy, greetings, good morning, good afternoon, good evening, sup, yo",
  "docent.patterns.help": "help, what can you do, how does this work, how do this work, how does it work, how do it work, commands, options",
  "docent.patterns.related": "show me something similar, show me something related, show me similar, show me related, show me like this, related, more like this, similar",
  "docent.patterns.whatIs": "what's this, what is this, where am i, what am i looking at, what am i seeing",
  "docent.related.list": "Here are datasets related to **{title}**:",
  "docent.related.noDataset": "There's no dataset loaded right now. Ask me about a topic and I'll find something to show you!",
  "docent.related.none": "I couldn't find datasets closely related to \"{title}\". Try asking about a specific topic instead.",
  "docent.search.fallbackResults": "I didn't find an exact match for \"{query}\", but here are some results for \"{word}\":",
  "docent.search.multipleMatches": "I found {count} datasets matching \"{query}\". Here's the best match:\n\n**{title}**\n{desc}{qa}",
  "docent.search.none": "I couldn't find datasets matching \"{query}\". Try different keywords, or ask me about a broad topic like \"ocean\", \"climate\", or \"space\".",
  "docent.search.singleMatch": "I found a dataset that matches: **{title}**\n\n{desc}{qa}",
  "docent.system.respondInLanguage": "Respond in {language}. Even when the user writes in English, your reply, dataset summaries, and any captions must be in {language}. Keep <<LOAD:DATASET_ID>> markers and tool-call syntax exactly as specified.",
  "docent.system.respondInLanguageReminder": "REMINDER: Reply only in {language} — even if the user typed in another language. Keep <<LOAD:...>> markers and tool-call syntax literal.",
  "download.manager.aria": "Download manager",
  "downloadUI.button.aria": "Download manager",
  "downloadUI.button.title": "Download Manager",
  "downloadUI.delete.aria": "Delete {title}",
  "downloadUI.delete.title": "Delete download",
  "downloadUI.downloaded.title": "Downloaded",
  "downloadUI.empty": "No datasets downloaded yet.<br>Use the &#8615; button on a dataset card to download it for offline use.",
  "downloadUI.failed.title": "Download failed: {error}",
  "downloadUI.title": "Downloads",
  "downloadUI.totalSize": "{size} total",
  "env.borders": "Borders",
  "env.clouds": "Clouds",
  "env.dayNight": "Day/night",
  "env.earth": "Earth",
  "env.stars": "Stars",
  "error.dismiss.aria": "Dismiss error",
  "help.button.label": "Help",
  "help.close.aria": "Close help",
  "help.feedback.contact.label": "Contact (optional)",
  "help.feedback.contact.placeholder": "Email or handle — only used to follow up if we have questions",
  "help.feedback.counter": "{count} / {max}",
  "help.feedback.kind.aria": "Feedback type",
  "help.feedback.kind.bug": "Bug report",
  "help.feedback.kind.feature": "Feature request",
  "help.feedback.kind.other": "Other",
  "help.feedback.message.label": "Describe what happened or what you'd like to see",
  "help.feedback.message.placeholder": "Tell us as much as you can — steps to reproduce, what you expected, and what actually happened.",
  "help.feedback.screenshot.label": "Attach a screenshot of the current view",
  "help.feedback.status.captureFailed": "Couldn't capture screenshot — sending text only…",
  "help.feedback.status.capturing": "Capturing screenshot…",
  "help.feedback.status.failed": "Couldn't send feedback",
  "help.feedback.status.failedReason": "Couldn't send feedback: {error}",
  "help.feedback.status.sending": "Sending…",
  "help.feedback.status.success": "Thanks! Your feedback was received.",
  "help.feedback.status.tooShort": "Please enter at least {min} characters.",
  "help.feedback.submit": "Send feedback",
  "help.guide.section.downloads": "<h3>Offline downloads</h3><ul><li>Click the download icon on any dataset card to cache it locally.</li><li>Downloaded datasets open instantly, even without an internet connection.</li><li>Manage cached datasets from the download panel to see sizes or delete old ones.</li></ul>",
  "help.guide.section.exploring": "<h3>Exploring datasets</h3><ul><li>Tap the <strong>Browse</strong> button in the bottom-right to open the dataset list.</li><li>Filter by category or search by keyword to narrow the list.</li><li>Click any card to load that dataset onto the globe.</li><li>The home button (top-left) returns you to the default Earth view and reopens browse.</li></ul>",
  "help.guide.section.multiglobe": "<h3>Multi-globe comparisons</h3><ul><li>In a multi-panel layout, camera motion syncs across every globe — drag any panel to rotate them all.</li><li>Each panel has a small numbered button in its top-left corner. Tap one to make it the active (primary) panel.</li><li>The next dataset you load goes into the active panel. Use the Browse button to pick another dataset for the next panel.</li><li>Time-series animations sync by <em>real-world date</em>, not video seconds — two datasets with different date ranges still line up correctly during any overlap. A panel whose dataset doesn't cover the current time is dimmed and marked \"No data for current time\". When playback is paused, each panel is checked against the time label; a panel that is not on that date says which date it <em>is</em> showing.</li></ul>",
  "help.guide.section.navigating": "<h3>Navigating the globe</h3><ul><li>Drag to rotate the Earth.</li><li>Scroll or pinch to zoom.</li><li>Double-click a location to focus on it.</li></ul>",
  "help.guide.section.orbit": "<h3>Talking to Orbit</h3><ul><li>Orbit is the digital docent — an AI assistant that can recommend datasets and explain what you're seeing.</li><li>Open the chat panel from the bottom-left trigger or the speech-bubble button in the browse panel.</li><li>Orbit can embed load buttons directly in its replies — click one to jump straight to that dataset.</li><li>Use the thumbs-up / thumbs-down buttons under each reply to rate Orbit's answers.</li><li>Configure the AI endpoint, model, and reading level from <strong>Tools → Orbit settings</strong>.</li><li>Press <kbd>Enter</kbd> to send a message.</li></ul>",
  "help.guide.section.privacy": "<h3>Privacy</h3><p>The app reports anonymous usage events &mdash; which layers load, how long they're viewed, whether anything errored. There is no account, no tracking cookie, and no third-party analytics service. Feedback you submit is stored with your browser's user agent and the page URL; attaching a screenshot is opt-in.</p><p>You can switch between Essential, Research, and Off under <strong>Tools &rarr; Privacy</strong>; the change takes effect immediately. <a href=\"/privacy\" target=\"_blank\" rel=\"noopener\">Read the full privacy policy &rarr;</a></p>",
  "help.guide.section.shortcuts": "<h3>Keyboard shortcuts</h3><ul><li><kbd>Esc</kbd> — close the active panel</li><li><kbd>Space</kbd> — toggle playback when a video dataset is loaded</li></ul>",
  "help.guide.section.tools": "<h3>Tools &amp; settings</h3><ul><li>The wrench icon next to Browse opens the <strong>Tools</strong> popover.</li><li><strong>View</strong> — toggle labels, borders, 3D terrain, auto-rotation, the dataset info panel, and dataset legends.</li><li><strong>Dataset info</strong> — show or hide the dataset metadata panel in the bottom-left. Hidden by default if you've turned it off previously; your preference is remembered.</li><li><strong>Legend</strong> — show or hide the legend for each loaded dataset. In multi-globe layouts each panel shows its own legend; tap a legend to enlarge.</li><li><strong>Layout</strong> — switch between a single globe or 2–4 synchronised globes that move together but can show different datasets side-by-side.</li><li><strong>Clear</strong> — remove any markers or highlighted regions.</li><li>Tap outside the popover or press <kbd>Esc</kbd> to close it.</li></ul>",
  "help.guide.section.tours": "<h3>Guided tours</h3><ul><li>Tours are scripted sequences that fly the camera, swap datasets, and narrate a topic.</li><li>Start a tour from the browse panel — tour cards are marked with a play icon.</li><li>Use the on-screen transport controls to play, pause, or skip between tour steps.</li><li>Some tours pause for questions or user input; click continue to resume.</li></ul>",
  "help.panel.title": "Help",
  "help.tab.feedback": "Feedback",
  "help.tab.guide": "Guide",
  "help.tablist.aria": "Help sections",
  "help.trigger.aria": "Open help and feedback",
  "help.trigger.title": "Help and feedback",
  "home.aria": "Browse datasets",
  "info.panel.aria": "Dataset information",
  "info.picker.aria": "Select dataset to view",
  "info.picker.label": "Showing info for",
  "infoPanel.captionsAvailable": "Captions available",
  "infoPanel.catalogLink": "View in SOS catalog ↗",
  "infoPanel.dateAdded": "Added",
  "infoPanel.description.showLess": "Show less",
  "infoPanel.description.showMore": "Show more",
  "infoPanel.developedBy": "Developed by",
  "infoPanel.inTheNews": "In the news",
  "infoPanel.news.timeOutOfRange": "This event is outside this dataset's time range.",
  "infoPanel.news.viewOnGlobe": "View on globe",
  "infoPanel.news.viewOnGlobe.aria": "View {title} on the globe",
  "infoPanel.relatedDatasets": "Related datasets",
  "infoPanel.section.credits": "Credits",
  "infoPanel.section.links": "Links",
  "infoPanel.source": "Source",
  "infoPanel.thumbnail.alt": "{title} thumbnail",
  "infoPanel.thumbnail.download": "Download thumbnail",
  "infoPanel.visualizationBy": "Visualization by",
  "loading.progress.aria": "Loading progress",
  "loading.status.initializing": "Initializing…",
  "loading.subtitle": "Science On a Sphere",
  "mapControls.fullscreen.enter": "Enter fullscreen",
  "mapControls.fullscreen.exit": "Exit fullscreen",
  "orbit.debug.announce.collapsed": "Debug panel collapsed",
  "orbit.debug.announce.expanded": "Debug panel expanded",
  "orbit.debug.flight.toEarth": "Orbit flying to Earth",
  "orbit.debug.flight.toHome": "Orbit returning to chat position",
  "orbit.debug.gesture.announce": "Playing {label}",
  "orbit.debug.gesture.aria": "Play {label} gesture",
  "orbit.debug.palette.announce": "Palette: {name}",
  "orbit.debug.palette.aria": "{name} palette",
  "orbit.debug.scale.announce": "Scale: {label}",
  "orbit.debug.stateGroup.behavior": "Behavior",
  "orbit.debug.stateGroup.emotion": "Emotion",
  "orbit.debug.stateGroup.head": "Head",
  "outputs.add": "Add output",
  "outputs.addFailed": "Could not add the output. {message}",
  "outputs.addFailed.generic": "The display did not accept a new window.",
  "outputs.adding": "Adding…",
  "outputs.close": "Close outputs",
  "outputs.decoders.hint": "Windows that can play video at once, across this one and every output. The default is what a single window reports; raise it only for a machine you have measured.",
  "outputs.decoders.label": "Decoder budget",
  "outputs.decoders.spent": "No decoders left. Close a globe panel or an output, or raise the budget.",
  "outputs.decoders.used": "{used} of {budget} video decoders in use",
  "outputs.intro": "Send a projection-corrected view of the live globe to another display — a Science On a Sphere projector, a dome, or a second monitor.",
  "outputs.item.calibration": "Calibration pattern",
  "outputs.item.debugOverlay": "Debug overlay (drawn on the output)",
  "outputs.item.framebuffer": "Framebuffer",
  "outputs.item.framebufferOption": "{width}×{height}",
  "outputs.item.health.gpuLost": "Display lost",
  "outputs.item.health.stale": "Link stale",
  "outputs.item.health.starting": "Starting",
  "outputs.item.healthAnnounce.gpuLost": "{monitor}: display lost. The output has lost its graphics context and is showing nothing.",
  "outputs.item.healthAnnounce.gpuRecovered": "{monitor}: display recovered. The output is drawing again.",
  "outputs.item.healthAnnounce.live": "{monitor}: in contact with the control window.",
  "outputs.item.healthAnnounce.stale": "{monitor}: link stale. The output is still showing its last frame.",
  "outputs.item.healthAnnounce.starting": "{monitor}: starting.",
  "outputs.item.healthAria.gpuLost": "This output has lost its graphics context and is showing nothing at all",
  "outputs.item.healthAria.stale": "This output has stopped hearing from the control window and is showing its last frame",
  "outputs.item.healthAria.starting": "This output has not reported in yet",
  "outputs.item.meta": "{width}×{height} · {mode}",
  "outputs.item.remove": "Remove",
  "outputs.item.removeAria": "Remove the output on {monitor}",
  "outputs.item.rotationOffset": "Rotation offset (°)",
  "outputs.item.split": "Split sphere",
  "outputs.item.trackCamera": "Track operator camera",
  "outputs.list.empty": "No outputs yet.",
  "outputs.list.title": "Active outputs",
  "outputs.loading": "Looking for displays…",
  "outputs.mode.label": "Output type",
  "outputs.mode.optionProjectorWarp": "Projector rig (sphere-sim warp)",
  "outputs.mode.optionSosEquirect": "LED sphere or dome (equirectangular)",
  "outputs.mode.projectorWarp": "Projector warp",
  "outputs.mode.sosEquirect": "SOS equirectangular",
  "outputs.monitor.mapSize": "{width}×{height}",
  "outputs.monitor.option": "{name} — {width}×{height}",
  "outputs.monitor.optionInUse": "{name} — {width}×{height} (already in use)",
  "outputs.monitor.optionPrimary": "{name} — {width}×{height} (primary)",
  "outputs.monitor.optionPrimaryInUse": "{name} — {width}×{height} (primary, already in use)",
  "outputs.monitor.unnamed": "Display {index}",
  "outputs.monitor.unnamedAt": "Display at {x}, {y}",
  "outputs.monitors.empty": "No displays were detected.",
  "outputs.monitors.label": "Display",
  "outputs.monitors.title": "Add an output",
  "outputs.restoreOnLaunch": "Restore outputs on launch",
  "outputs.restoreOnLaunch.hint": "Reopen these outputs automatically next time, on the same displays.",
  "outputs.singleMonitor": "Only one display was detected. An output fills the display it opens on, so it will cover this window.",
  "outputs.title": "Outputs",
  "outputs.unavailable": "Outputs are unavailable in this session.",
  "outputs.warp.arrived.one": "Read 1 mesh: {ids}.",
  "outputs.warp.arrived.other": "Read {count} meshes: {ids}.",
  "outputs.warp.askQuadrants": "Nothing picked says where these meshes go or what frame they address. Import them only if you know both: they address an equirectangular frame, as a sphere's meshes do, and they belong in Science On a Sphere's four quadrants of this display. A mesh made for a dome or a mirror usually addresses a fisheye frame, and here it would draw a smooth picture that is wrong.",
  "outputs.warp.aspectMismatch.one": "{ids} was solved for a {mesh}:1 raster, but its part of this display is {viewport}:1, so its picture will be stretched by {percent}%.",
  "outputs.warp.aspectMismatch.other": "{ids} were solved for {mesh}:1 rasters, but their parts of this display are {viewport}:1, so their pictures will be stretched by {percent}%.",
  "outputs.warp.bakedRotationMesh": "These meshes address a model's own texture layout, which has no rotation.",
  "outputs.warp.bakedRotationSphere": "The sphere's rotation, {degrees}°, is already in these meshes. Leave the content rotation at 0 unless you mean to turn the picture.",
  "outputs.warp.blendGamma": "Blend gamma",
  "outputs.warp.blendGammaHint": "The display gamma the projectors' blend weights are applied through. 2.2 unless your calibration says otherwise.",
  "outputs.warp.bundlePlaces": "The bundle says where each mesh goes on this display:",
  "outputs.warp.cancel": "Cancel",
  "outputs.warp.clear": "Clear warp",
  "outputs.warp.clearAria": "Clear the warp from the output on {monitor}",
  "outputs.warp.contentRotation": "Content rotation (°)",
  "outputs.warp.framebufferDifferentShape": "Solved for a {solvedWidth}×{solvedHeight} display, but this one is {width}×{height}, a different shape.",
  "outputs.warp.framebufferResampled": "Solved for a {solvedWidth}×{solvedHeight} display. This one is {width}×{height}, the same shape, so every mesh is resampled to fit.",
  "outputs.warp.framebufferStretched.one": "Solved for a {solvedWidth}×{solvedHeight} display, but this one is {width}×{height}, a different shape, so the projector's picture will be stretched by {percent}%.",
  "outputs.warp.framebufferStretched.other": "Solved for a {solvedWidth}×{solvedHeight} display, but this one is {width}×{height}, a different shape, so every projector's picture will be stretched by {percent}%.",
  "outputs.warp.import": "Import warp…",
  "outputs.warp.importAria": "Import a sphere-sim warp bundle for the output on {monitor}",
  "outputs.warp.loaded.one": "Drawing 1 mesh: {ids}.",
  "outputs.warp.loaded.other": "Drawing {count} meshes: {ids}.",
  "outputs.warp.nativeSize": "Framebuffer: this display's own {width}×{height}",
  "outputs.warp.none": "No warp set. This output draws nothing until one is imported.",
  "outputs.warp.quadrantsKey": "P1 bottom left, P2 bottom right, P3 top left, P4 top right.",
  "outputs.warp.readFailed": "The chosen files could not be read.",
  "outputs.warp.reading": "Reading…",
  "outputs.warp.refusal.archive": "{file} could not be read as a sphere-sim bundle ({reason}).",
  "outputs.warp.refusal.archiveChecksum": "{entry} in {file} does not match its checksum, so it was damaged on its way here. Export the bundle again.",
  "outputs.warp.refusal.archiveCompressed": "{file} was compressed again after sphere-sim exported it, which this reader does not undo. Extract it and pick the .data files from its warp folder instead.",
  "outputs.warp.refusal.badName": "{file} does not name a projector.",
  "outputs.warp.refusal.bundleLayout": "{file} cannot be used ({reason}), so nothing this build can trust says where the bundle's meshes go.",
  "outputs.warp.refusal.bundleLayoutFormat": "{file} is in a format this build does not read ({format}), so nothing it can trust says where the bundle's meshes go.",
  "outputs.warp.refusal.bundleLayoutUv": "{file} says its meshes address \"{uv}\", not an equirectangular frame. This build draws only meshes made for an equirectangular frame, so nothing is imported.",
  "outputs.warp.refusal.duplicateId": "More than one mesh for {ids}.",
  "outputs.warp.refusal.layoutDuplicate": "Two meshes claim one quadrant: {ids}.",
  "outputs.warp.refusal.layoutUnplaceable": "SOS's quadrants have no place for {ids}. This rig's layout has to come from the bundle, which sphere-sim does not write yet.",
  "outputs.warp.refusal.mesh": "{file} is not a warp mesh this output can read ({reason}).",
  "outputs.warp.refusal.meshAtLine": "{file} is not a warp mesh this output can read ({reason}, line {line}).",
  "outputs.warp.refusal.mixedSelection": "Pick one sphere-sim ZIP, or the .data files from one — not both, and not two ZIPs.",
  "outputs.warp.refusal.noMeshes": "{file} holds no warp meshes (warp/<id>.data). Is it a sphere-sim export?",
  "outputs.warp.refusal.noOutput": "That output is no longer open.",
  "outputs.warp.refusal.noRoom": "There is no room left to keep this warp set. Clear the warp from an output that no longer needs it, then import again.",
  "outputs.warp.refusal.notAWarpOutput": "Only a projector-warp output draws a warp.",
  "outputs.warp.refusal.notText": "{file} is not a text file, so it is not a warp mesh.",
  "outputs.warp.refusal.nothingPicked": "No file was chosen.",
  "outputs.warp.refusal.set": "The warp set was refused ({reason}).",
  "outputs.warp.refusal.tooLarge": "That selection is {megabytes} MB, far larger than any warp bundle. Pick the sphere-sim ZIP, or the .data files inside it.",
  "outputs.warp.refusal.tooMany": "{count} meshes is more than one output can carry.",
  "outputs.warp.refusal.unavailable": "This window cannot keep a warp set between launches, so it was not imported.",
  "outputs.warp.refusal.unsupportedFile": "{file} is neither a sphere-sim ZIP nor a .data warp mesh.",
  "outputs.warp.title": "Projector warp",
  "outputs.warp.unreadable": "The warp set this output uses could not be read, so it draws nothing. Import it again.",
  "outputs.warp.useBundleLayout": "Import",
  "outputs.warp.useQuadrants": "Import as equirectangular in SOS quadrants",
  "outputs.warp.viewportEntry": "{id}: {width}% of the display wide and {height}% tall, {left}% in from the left edge and {bottom}% up from the bottom.",
  "outputs.warp.warpRotationMesh": "Warp rotation: none. The meshes address the model's own texture layout.",
  "outputs.warp.warpRotationSphere": "Warp rotation: {degrees}°, already in the meshes. Do not enter it again as the content rotation.",
  "outputs.warp.warpRotationUnknown": "Warp rotation: unknown — the bundle does not say.",
  "playback.announce.paused": "Playback paused",
  "playback.announce.started": "Playback started",
  "playback.captions.aria": "Toggle closed captions",
  "playback.captions.label": "Closed Captions",
  "playback.error.dateOutsideRange": "Date {date} is outside this dataset's range ({start} to {end})",
  "playback.error.invalidDate": "Invalid date format",
  "playback.error.invalidTimeRange": "Dataset has invalid time range",
  "playback.error.noTimeRange": "Dataset has no time range",
  "playback.error.noVideoDataset": "No video dataset loaded",
  "playback.error.videoNotReady": "Video not ready",
  "playback.fastForward.aria": "Fast-forward to end",
  "playback.nextInPlaylist.aria": "Skip to next playlist item",
  "playback.nextInPlaylist.title": "Next in playlist",
  "playback.pause.aria": "Pause",
  "playback.play.aria": "Play",
  "playback.playPause.title": "Play / Pause",
  "playback.rewind.aria": "Rewind to start",
  "playback.scrubber.aria": "Playback position",
  "playback.seekingTo": "Seeking to {date}",
  "playback.stepBack.aria": "Step back one frame",
  "playback.stepForward.aria": "Step forward one frame",
  "playback.toolbar.aria": "Playback controls",
  "playback.unmute.aria": "Unmute audio",
  "playlist.action.addToPlaylist": "Add to playlist",
  "playlist.action.addToPlaylist.aria": "Add {title} to a playlist",
  "playlist.add.popover.close.aria": "Close add to playlist",
  "playlist.add.popover.empty": "You don't have any playlists yet.",
  "playlist.add.popover.newOption": "+ New playlist…",
  "playlist.add.popover.title": "Add to playlist",
  "playlist.added.announce": "Added {title} to {playlist}",
  "playlist.alreadyIn.announce": "{title} is already in {playlist}",
  "playlist.button.aria": "Open playlist manager",
  "playlist.button.title": "Playlists",
  "playlist.collapse.aria": "Collapse playlist {name}",
  "playlist.continue.aria": "Continue playlist",
  "playlist.continue.label": "Click to continue",
  "playlist.create.defaultName": "My playlist",
  "playlist.create.prompt": "Name your new playlist:",
  "playlist.delete.aria": "Delete playlist {name}",
  "playlist.delete.confirm": "Delete playlist \"{name}\"? This cannot be undone.",
  "playlist.duration.helper": "Time before advancing to the next dataset. Leave blank for the 30-second default.",
  "playlist.duration.label": "Duration (seconds)",
  "playlist.duration.prefix": "Show for",
  "playlist.duration.suffix": "sec",
  "playlist.empty.message": "No playlists yet. Add datasets from Browse or the info panel to start one.",
  "playlist.entry.empty": "This playlist has no datasets yet.",
  "playlist.entry.moveDown.aria": "Move {title} down",
  "playlist.entry.moveUp.aria": "Move {title} up",
  "playlist.entry.pauseForInput.aria": "Wait for click before advancing past {title}",
  "playlist.entry.pauseForInput.label": "Wait for click",
  "playlist.entry.remove.aria": "Remove {title} from playlist",
  "playlist.expand.aria": "Expand playlist {name}",
  "playlist.export.filename": "terraviz-playlists.json",
  "playlist.export.label": "Export to JSON",
  "playlist.import.error.invalidJson": "That file isn't valid JSON.",
  "playlist.import.error.noPlaylists": "No valid playlists found in that file.",
  "playlist.import.error.tooBig": "That file is too large (1 MB maximum).",
  "playlist.import.label": "Import from JSON",
  "playlist.import.success.one": "Imported 1 playlist.",
  "playlist.import.success.other": "Imported {count} playlists.",
  "playlist.loop.aria": "Loop playlist {name}",
  "playlist.loop.label": "Loop",
  "playlist.manager.close.aria": "Close playlist manager",
  "playlist.manager.title": "Playlists",
  "playlist.new.button": "+ New playlist",
  "playlist.new.button.aria": "Create new playlist",
  "playlist.persistence.warning": "Playlists are stored only in this browser. Use Export to back them up or move them to another device.",
  "playlist.play.aria": "Play playlist {name}",
  "playlist.play.label": "Play",
  "playlist.playing.label": "Playing",
  "playlist.rename.aria": "Rename playlist {name}",
  "playlist.rename.prompt": "Rename playlist:",
  "playlist.search.aria": "Filter playlists by name",
  "playlist.search.empty": "No playlists match “{query}”.",
  "playlist.search.placeholder": "Search playlists…",
  "playlist.stop.announce": "Stopped playlist {name}",
  "playlist.stop.aria": "Stop playlist {name}",
  "playlist.unknownDataset": "Unknown dataset",
  "privacy.announce.off": "Telemetry off. Pending events discarded.",
  "privacy.announce.set": "Telemetry set to {tier}.",
  "privacy.clearVisits.announce": "Visit history cleared.",
  "privacy.clearVisits.confirm": "Clear your local visit history? This removes the “Continue exploring” row and the recently-viewed history on this device. It can't be undone.",
  "privacy.clearVisits.label": "Clear visit history",
  "privacy.clearVisits.labelCount": "Clear visit history ({count})",
  "privacy.close.aria": "Close privacy settings",
  "privacy.desc": "Choose how much the app reports back. You can change this at any time; the change takes effect immediately.",
  "privacy.localNote.visitMemory": "Visit memory (the datasets you've opened, used for “Continue exploring” and the “new since your last visit” badge) is stored only on this device — never sent to servers. Clearing site data removes it.",
  "privacy.policyLink": "Read the full privacy policy →",
  "privacy.radiogroup.aria": "Telemetry tier",
  "privacy.session.hint": "In-memory only · resets on relaunch",
  "privacy.session.label": "Session ID",
  "privacy.tier.essential.desc": "Anonymous health and usage events so we can keep the app working. On by default.",
  "privacy.tier.essential.label": "Essential",
  "privacy.tier.off.desc": "No telemetry events are sent. The app works exactly the same.",
  "privacy.tier.off.label": "Off",
  "privacy.tier.research.desc": "Adds panel dwell times, Orbit interactions, and sanitized stack frames so we can improve the docent. Opt-in.",
  "privacy.tier.research.label": "Research",
  "privacy.title": "Privacy",
  "probe.noData": "No data",
  "probe.value": "{value} {units}",
  "probe.valueNoUnits": "{value}",
  "publisher.account.cancel": "Cancel",
  "publisher.account.field.affiliation": "Affiliation",
  "publisher.account.field.affiliation.hint": "Used as attribution on the datasets and tours you publish.",
  "publisher.account.field.displayName": "Display name",
  "publisher.account.field.displayName.hint": "Shown on tours and blog posts you author.",
  "publisher.account.profile.heading": "Profile",
  "publisher.account.readonlyNote": "Contact an admin to change your profile details.",
  "publisher.account.save": "Save changes",
  "publisher.account.saveError": "Couldn't save your changes — try again.",
  "publisher.account.saved": "Saved ✓",
  "publisher.account.saving": "Saving…",
  "publisher.account.security.change": "Change",
  "publisher.account.security.changePassword": "Change password",
  "publisher.account.security.email": "Email",
  "publisher.account.security.enable2fa": "Enable 2FA",
  "publisher.account.security.heading": "Account & security",
  "publisher.account.security.idpNote": "Sign-in, password, and two-factor authentication are handled by your identity provider (Cloudflare Access), not here.",
  "publisher.account.security.password": "Password",
  "publisher.account.security.passwordMasked": "Managed externally",
  "publisher.account.security.twofa": "Two-factor auth",
  "publisher.account.security.twofaStatus": "Managed by provider",
  "publisher.account.sessions.heading": "Active sessions",
  "publisher.account.sessions.unavailable": "Session management is handled by your identity provider and isn't available in the portal yet.",
  "publisher.analytics.controls.environment": "Environment",
  "publisher.analytics.controls.range": "Range",
  "publisher.analytics.controls.rangeDays": "Last {days} days",
  "publisher.analytics.datasets.approxNote": "≈p50/≈p95 are loads-weighted averages of daily percentiles, not true range percentiles.",
  "publisher.analytics.datasets.dataset": "Dataset",
  "publisher.analytics.datasets.dwell": "On-globe dwell",
  "publisher.analytics.datasets.loadP50": "Load ≈p50",
  "publisher.analytics.datasets.loadP95": "Load ≈p95",
  "publisher.analytics.datasets.loads": "Loads",
  "publisher.analytics.datasets.sources": "Sources",
  "publisher.analytics.datasets.triggers": "Triggers",
  "publisher.analytics.empty": "No data in this range yet.",
  "publisher.analytics.env.preview": "Preview",
  "publisher.analytics.env.production": "Production",
  "publisher.analytics.errors.category": "Category",
  "publisher.analytics.errors.code": "Code",
  "publisher.analytics.errors.count": "Count",
  "publisher.analytics.errors.expandHint": "View breakdown",
  "publisher.analytics.errors.message": "Message",
  "publisher.analytics.errors.orderNote": "Ordered by frequency (sample-weighted estimates).",
  "publisher.analytics.errors.source": "Source",
  "publisher.analytics.errors.title": "Error breakdown",
  "publisher.analytics.exportCsv": "Export CSV",
  "publisher.analytics.freshness": "Sample-weighted estimates from the nightly rollups — complete UTC days through yesterday, external traffic only.",
  "publisher.analytics.funnel.autoExcluded": "Auto-tours (excluded)",
  "publisher.analytics.funnel.completionRate": "Tour completion",
  "publisher.analytics.funnel.orbitTurns": "Orbit turns",
  "publisher.analytics.funnel.tourOutcomes": "Tour outcomes",
  "publisher.analytics.funnel.toursEnded": "Tours ended",
  "publisher.analytics.funnel.toursStarted": "Tours started",
  "publisher.analytics.funnel.userStarted": "User-started tours",
  "publisher.analytics.funnel.vrModes": "VR session modes",
  "publisher.analytics.funnel.vrSessions": "VR sessions",
  "publisher.analytics.loading": "Loading analytics…",
  "publisher.analytics.orbit.empty": "No Orbit usage in this range (Research-tier; needs opt-in).",
  "publisher.analytics.orbit.inputTokens": "Input tokens",
  "publisher.analytics.orbit.model": "Model",
  "publisher.analytics.orbit.outputTokens": "Output tokens",
  "publisher.analytics.orbit.rounds": "LLM rounds",
  "publisher.analytics.orbit.roundsPerDay": "LLM rounds per day",
  "publisher.analytics.orbit.turns": "Turns",
  "publisher.analytics.overview.countries": "Top countries",
  "publisher.analytics.overview.country": "Country",
  "publisher.analytics.overview.errorRate": "Errors per session",
  "publisher.analytics.overview.errors": "Errors",
  "publisher.analytics.overview.events": "Events",
  "publisher.analytics.overview.operatingSystems": "OS mix",
  "publisher.analytics.overview.platforms": "Platform mix",
  "publisher.analytics.overview.sessions": "Sessions",
  "publisher.analytics.overview.sessionsPerDay": "Sessions per day",
  "publisher.analytics.overview.viewTime": "Total view time",
  "publisher.analytics.overview.viewTimePerDay": "View time per day (minutes)",
  "publisher.analytics.perf.fps": "Avg FPS",
  "publisher.analytics.perf.frameP95": "Avg frame p95",
  "publisher.analytics.perf.jsheap": "Avg JS heap",
  "publisher.analytics.perf.note": "Averages over the range, weighted by sample count; JS heap excludes browsers that don't report it.",
  "publisher.analytics.perf.renderer": "GPU / renderer",
  "publisher.analytics.perf.samples": "Samples",
  "publisher.analytics.perf.surface": "Surface",
  "publisher.analytics.research.answered": "Answered",
  "publisher.analytics.research.avgDwell": "Avg dwell",
  "publisher.analytics.research.avgLatency": "Avg latency",
  "publisher.analytics.research.avgLength": "Avg length",
  "publisher.analytics.research.avgMagnitude": "Avg magnitude",
  "publisher.analytics.research.correctRate": "Correct rate",
  "publisher.analytics.research.corrections": "Orbit correction signals",
  "publisher.analytics.research.count": "Count",
  "publisher.analytics.research.dwell": "Panel dwell",
  "publisher.analytics.research.empty": "No research-tier data in this range (needs opt-in).",
  "publisher.analytics.research.followThrough": "Orbit follow-through",
  "publisher.analytics.research.gestures": "VR gesture mix",
  "publisher.analytics.research.key": "Value",
  "publisher.analytics.research.question": "Question",
  "publisher.analytics.research.topSearches": "Top searches (hashed)",
  "publisher.analytics.research.tour": "Tour",
  "publisher.analytics.research.worstQuestions": "Worst-answered quiz questions",
  "publisher.analytics.research.zeroSearches": "Zero-result searches (hashed)",
  "publisher.analytics.section.datasets": "Dataset engagement",
  "publisher.analytics.section.funnel": "Tours, VR & Orbit",
  "publisher.analytics.section.orbit": "Orbit usage",
  "publisher.analytics.section.overview": "Overview",
  "publisher.analytics.section.perf": "Performance",
  "publisher.analytics.section.research": "Research (Tier B)",
  "publisher.analytics.section.spatial": "Spatial attention",
  "publisher.analytics.spatial.allDatasets": "All datasets",
  "publisher.analytics.spatial.allProjections": "All projections",
  "publisher.analytics.spatial.dataset": "Dataset",
  "publisher.analytics.spatial.defaultEarth": "Default Earth",
  "publisher.analytics.spatial.event": "Signal",
  "publisher.analytics.spatial.eventCamera": "Camera attention",
  "publisher.analytics.spatial.eventClicks": "Map clicks",
  "publisher.analytics.spatial.hitKinds": "Click target mix",
  "publisher.analytics.spatial.mapAria": "Heatmap of where users look on the globe",
  "publisher.analytics.spatial.projAr": "AR gaze",
  "publisher.analytics.spatial.projGlobe": "Globe (2D)",
  "publisher.analytics.spatial.projMercator": "Mercator (2D)",
  "publisher.analytics.spatial.projVr": "VR gaze",
  "publisher.analytics.spatial.projection": "Projection",
  "publisher.analytics.tab.datasets": "Datasets",
  "publisher.analytics.tab.engagement": "Engagement",
  "publisher.analytics.tab.orbit": "Orbit",
  "publisher.analytics.tab.overview": "Overview",
  "publisher.analytics.tab.performance": "Performance",
  "publisher.analytics.tab.research": "Research",
  "publisher.analytics.tab.spatial": "Spatial",
  "publisher.analytics.tabs.aria": "Analytics sections",
  "publisher.analytics.tierBNote": "Research-tier signal — only from sessions that opted into Research mode, so sparse unless users opt in.",
  "publisher.analytics.title": "Analytics",
  "publisher.api.fallbackError.invalidJson": "The server rejected the request.",
  "publisher.api.fallbackError.validationFailed": "Validation failed.",
  "publisher.assetUploader.completeMissingRef": "Upload finished, but the server didn't return a saved reference. Please retry.",
  "publisher.assetUploader.current": "Current reference:",
  "publisher.assetUploader.errorDetails": "Show details",
  "publisher.assetUploader.frames.frameCount": "{count} frame(s), {size} total",
  "publisher.assetUploader.frames.hashingProgress": "Hashing frame {current}/{total}…",
  "publisher.assetUploader.frames.mixedMime": "All frames must be the same type. Picked {actual} after {expected}.",
  "publisher.assetUploader.frames.pickFiles": "Pick frames:",
  "publisher.assetUploader.frames.startUpload": "Upload {count} frame(s)",
  "publisher.assetUploader.frames.tooMany": "Picked {actual} frames; the cap is {max}.",
  "publisher.assetUploader.frames.totalSizeExceeded": "Aggregate size {actual} exceeds the {max} cap.",
  "publisher.assetUploader.frames.unsupportedMime": "Frames must be PNG, JPEG, or WebP. Picked file type: {actual}.",
  "publisher.assetUploader.frames.uploadingProgress": "Uploading frame {current}/{total}…",
  "publisher.assetUploader.generate.cancel": "Cancel",
  "publisher.assetUploader.generate.capture": "Capture this frame",
  "publisher.assetUploader.generate.degrees": "{value}°",
  "publisher.assetUploader.generate.discard": "Discard",
  "publisher.assetUploader.generate.error": "Couldn't generate a globe thumbnail.",
  "publisher.assetUploader.generate.fromData": "Generate from this dataset's data",
  "publisher.assetUploader.generate.fromFrame": "Generate from a 2:1 frame…",
  "publisher.assetUploader.generate.heading": "Generate a globe thumbnail",
  "publisher.assetUploader.generate.help": "Wrap a 2:1 (equirectangular) data frame around a globe and capture it as the browse-card thumbnail. Use the dataset's own data, or pick a representative frame.",
  "publisher.assetUploader.generate.latitude": "Latitude",
  "publisher.assetUploader.generate.longitude": "Longitude",
  "publisher.assetUploader.generate.previewAlt": "Preview of the generated globe thumbnail",
  "publisher.assetUploader.generate.rendering": "Rendering the globe…",
  "publisher.assetUploader.generate.rotateHint": "Rotate to bring your area of focus to the centre.",
  "publisher.assetUploader.generate.scrubHint": "Scrub the video to the frame you want, then capture it.",
  "publisher.assetUploader.generate.use": "Use this thumbnail",
  "publisher.assetUploader.generate.videoLoading": "Loading video…",
  "publisher.assetUploader.mimeMismatch": "Picked file type ({actual}) doesn't match the dataset's declared format ({expected}). Change the dataset's format first, or pick a matching file.",
  "publisher.assetUploader.mimeNotImage": "Picked file type ({actual}) isn't a supported image. Use PNG, JPEG, or WebP.",
  "publisher.assetUploader.pickFile": "Pick a file:",
  "publisher.assetUploader.publishAsIs.fpsWarning": "This file is {fps} fps, not {expected}. Tour playback speed assumes {expected} fps, and publishing as uploaded skips the step that would normalise it.",
  "publisher.assetUploader.publishAsIs.help": "This dataset is data-encoded, so the pixels are measurements rather than a picture. Re-encoding would resample the frame to 4096×2048 and change the values. Untick to send it through the normal transcode instead.",
  "publisher.assetUploader.publishAsIs.label": "Publish this file as uploaded (no re-encode)",
  "publisher.assetUploader.sessionExpired": "Session expired.",
  "publisher.assetUploader.status.completing": "Verifying upload…",
  "publisher.assetUploader.status.doneDirect": "Upload complete.",
  "publisher.assetUploader.status.doneTranscoding": "Upload complete. Transcoding the video — this can take a few minutes.",
  "publisher.assetUploader.status.error": "Upload failed.",
  "publisher.assetUploader.status.hashing": "Hashing file…",
  "publisher.assetUploader.status.idle": "Choose a file to upload.",
  "publisher.assetUploader.status.minting": "Requesting upload URL…",
  "publisher.assetUploader.status.savingDraft": "Saving draft…",
  "publisher.assetUploader.status.uploading": "Uploading…",
  "publisher.assetUploader.tab.frames": "Upload frames",
  "publisher.assetUploader.tab.video": "Upload MP4",
  "publisher.blog.col.link": "Actions",
  "publisher.blog.col.title": "Title",
  "publisher.blog.col.updated": "Updated",
  "publisher.blog.editor.back": "Back to blog",
  "publisher.blog.editor.headingEdit": "Edit post",
  "publisher.blog.editor.headingNew": "New post",
  "publisher.blog.editor.navAria": "Post sections",
  "publisher.blog.editor.title": "Post content",
  "publisher.blog.empty": "No posts yet. Generate your first draft from datasets and a current event.",
  "publisher.blog.error.generic": "Something went wrong. Try again.",
  "publisher.blog.error.required": "A title and body are required.",
  "publisher.blog.error.session": "Your session has expired — sign in again.",
  "publisher.blog.event.label": "Cited event (optional)",
  "publisher.blog.event.none": "No event",
  "publisher.blog.field.body": "Body (markdown)",
  "publisher.blog.field.summary": "Summary (shown under the title)",
  "publisher.blog.field.title": "Title",
  "publisher.blog.generate.done": "Draft ready — review and edit below.",
  "publisher.blog.generate.doneTourFailed": "Draft ready. Companion tour failed: {reason}",
  "publisher.blog.generate.doneWithTour": "Draft ready, and a companion tour draft was created (see Tours).",
  "publisher.blog.generate.includeTour": "Also generate a companion tour from the cited event",
  "publisher.blog.generate.intro": "Draft the post from your selected sources with AI. You edit the result from there — nothing is saved until you choose to.",
  "publisher.blog.generate.length": "Length",
  "publisher.blog.generate.length.long": "Long (~900 words)",
  "publisher.blog.generate.length.medium": "Medium (~500 words)",
  "publisher.blog.generate.length.short": "Short (~250 words)",
  "publisher.blog.generate.needDatasets": "Select at least one dataset first.",
  "publisher.blog.generate.previewTour": "Preview the companion tour",
  "publisher.blog.generate.run": "Generate draft",
  "publisher.blog.generate.tone": "Tone (optional — defaults to the node profile's tone)",
  "publisher.blog.generate.tonePlaceholder": "e.g. curious, educational",
  "publisher.blog.generate.working": "Generating — this can take up to 30 seconds…",
  "publisher.blog.grounding.intro": "Pick the datasets this post draws on, and optionally cite the current event that prompted it. These selections feed the AI draft and become the post's citations.",
  "publisher.blog.list.edit": "Edit",
  "publisher.blog.list.view": "View post",
  "publisher.blog.loading": "Loading…",
  "publisher.blog.media.commonsEmpty": "Nearby photos: no public-domain photos found near this event's location.",
  "publisher.blog.media.coverLabel": "Cover image",
  "publisher.blog.media.eventImage": "Story image",
  "publisher.blog.media.hintNeedsDate": "Satellite view: add an occurred date to this event (in the Events tab).",
  "publisher.blog.media.hintNeedsLocation": "Add a location to this event (in the Events tab) to enable satellite views and nearby photos.",
  "publisher.blog.media.hintUnknownRegion": "“{region}” isn't a recognized region, so satellite views and nearby photos are unavailable — pick a known region from the list or drop coordinates on the event (Events tab).",
  "publisher.blog.media.insert": "Insert into post",
  "publisher.blog.media.intro": "Suggested imagery for the cited event — satellite views, freely-licensed photos, and video. Insert any of these into the post body, or set one as the post's cover image.",
  "publisher.blog.media.needEvent": "Cite a current event on the Sources tab to see suggested media.",
  "publisher.blog.media.nhcEmpty": "Hazard map: no active storm matched this event's name.",
  "publisher.blog.media.noCover": "No cover image set. Pick one from the suggestions below.",
  "publisher.blog.media.notShownLabel": "Not shown for this event:",
  "publisher.blog.media.removeCover": "Remove cover",
  "publisher.blog.media.setCover": "Set as cover",
  "publisher.blog.media.shakemapEmpty": "Hazard map: no USGS ShakeMap found for this earthquake.",
  "publisher.blog.media.suggestionsLabel": "Suggested media",
  "publisher.blog.media.videoSitemapEmpty": "Agency video: none matched this event (or no video source is registered).",
  "publisher.blog.media.youtubeEmpty": "Video: none matched this event (or no video source is configured).",
  "publisher.blog.new": "New post",
  "publisher.blog.picker.label": "Datasets",
  "publisher.blog.picker.none": "No datasets selected yet.",
  "publisher.blog.picker.removeAria": "Remove {title}",
  "publisher.blog.picker.searchPlaceholder": "Search published datasets…",
  "publisher.blog.publish": "Publish",
  "publisher.blog.published": "Published — live at /blog/{slug}.",
  "publisher.blog.readonly.notice": "You have view-only access to this post — only its author can edit it.",
  "publisher.blog.save": "Save draft",
  "publisher.blog.saved": "Saved.",
  "publisher.blog.status.draft": "Draft",
  "publisher.blog.status.published": "Published",
  "publisher.blog.subtitle": "Long-form posts grounded in your datasets and current events.",
  "publisher.blog.tab.aiDraft": "AI draft",
  "publisher.blog.tab.content": "Content",
  "publisher.blog.tab.media": "Media",
  "publisher.blog.tab.sources": "Sources",
  "publisher.blog.title": "Blog",
  "publisher.blog.unpublish": "Unpublish",
  "publisher.blog.unpublished": "Unpublished — back to draft.",
  "publisher.chipInput.remove.aria": "Remove {value}",
  "publisher.datasetDetail.action.confirm.publish": "Publish this dataset? It will appear in the public catalog immediately.",
  "publisher.datasetDetail.action.confirm.retract": "Retract this dataset? It will be hidden from the public catalog. You can re-publish later.",
  "publisher.datasetDetail.action.error.network": "Couldn't reach the server. Check your connection and try again.",
  "publisher.datasetDetail.action.error.server": "The server returned an error ({detail}). Check the deployment's bindings, then try again.",
  "publisher.datasetDetail.action.error.session": "Your session has expired. Refresh the page to sign in again.",
  "publisher.datasetDetail.action.error.validation": "The server rejected the action. Edit the dataset to fix the validation errors and try again.",
  "publisher.datasetDetail.action.error.validationPrefix": "Can't publish — the server returned these validation errors:",
  "publisher.datasetDetail.action.preview": "Preview",
  "publisher.datasetDetail.action.publish": "Publish",
  "publisher.datasetDetail.action.publishDisabledTranscoding": "Waiting on transcode to finish before this can be published.",
  "publisher.datasetDetail.action.publishing": "Publishing…",
  "publisher.datasetDetail.action.retract": "Retract",
  "publisher.datasetDetail.action.retracting": "Retracting…",
  "publisher.datasetDetail.backToList": "Back to all datasets",
  "publisher.datasetDetail.editAction": "Edit",
  "publisher.datasetDetail.field.attribution": "Attribution",
  "publisher.datasetDetail.field.captionRef": "Captions",
  "publisher.datasetDetail.field.citation": "Citation",
  "publisher.datasetDetail.field.createdAt": "Created",
  "publisher.datasetDetail.field.dataRef": "Data reference",
  "publisher.datasetDetail.field.doi": "DOI",
  "publisher.datasetDetail.field.endTime": "End time",
  "publisher.datasetDetail.field.format": "Format",
  "publisher.datasetDetail.field.id": "ID",
  "publisher.datasetDetail.field.legacyId": "Legacy ID",
  "publisher.datasetDetail.field.legendRef": "Legend",
  "publisher.datasetDetail.field.licenseSpdx": "License (SPDX)",
  "publisher.datasetDetail.field.licenseStatement": "License statement",
  "publisher.datasetDetail.field.licenseUrl": "License URL",
  "publisher.datasetDetail.field.organization": "Organization",
  "publisher.datasetDetail.field.period": "Period",
  "publisher.datasetDetail.field.publishedAt": "Published",
  "publisher.datasetDetail.field.publisherId": "Publisher ID",
  "publisher.datasetDetail.field.retractedAt": "Retracted",
  "publisher.datasetDetail.field.rightsHolder": "Rights holder",
  "publisher.datasetDetail.field.runTourOnLoad": "Tour on load",
  "publisher.datasetDetail.field.startTime": "Start time",
  "publisher.datasetDetail.field.thumbnailRef": "Thumbnail",
  "publisher.datasetDetail.field.updatedAt": "Updated",
  "publisher.datasetDetail.field.visibility": "Visibility",
  "publisher.datasetDetail.field.websiteLink": "Website",
  "publisher.datasetDetail.loading": "Loading dataset…",
  "publisher.datasetDetail.media.legend": "Legend",
  "publisher.datasetDetail.media.thumbnail": "Thumbnail",
  "publisher.datasetDetail.notFound": "Dataset not found. It may have been deleted, or you may not have access.",
  "publisher.datasetDetail.preview.body": "This link opens the draft as a live globe rendering for the next {minutes} minutes. Anyone with the link can view the draft until it expires.",
  "publisher.datasetDetail.preview.close": "Close",
  "publisher.datasetDetail.preview.copied": "Copied!",
  "publisher.datasetDetail.preview.copy": "Copy link",
  "publisher.datasetDetail.preview.heading": "Preview link ready",
  "publisher.datasetDetail.preview.urlAriaLabel": "Preview URL",
  "publisher.datasetDetail.section.abstract": "Abstract",
  "publisher.datasetDetail.section.assets": "Assets",
  "publisher.datasetDetail.section.categorization": "Keywords & tags",
  "publisher.datasetDetail.section.identity": "Identity",
  "publisher.datasetDetail.section.keywords": "Keywords",
  "publisher.datasetDetail.section.licensing": "Licensing & attribution",
  "publisher.datasetDetail.section.lifecycle": "Lifecycle",
  "publisher.datasetDetail.section.media": "Preview",
  "publisher.datasetDetail.section.tags": "Tags",
  "publisher.datasetDetail.transcoding.badge": "Transcoding…",
  "publisher.datasetEdit.loading": "Loading dataset…",
  "publisher.datasetForm.action.cancel": "Cancel",
  "publisher.datasetForm.action.edit": "Edit",
  "publisher.datasetForm.action.preview": "Preview",
  "publisher.datasetForm.action.saveDraft": "Save draft",
  "publisher.datasetForm.action.saving": "Saving…",
  "publisher.datasetForm.chooser.applied": "Applied ✓",
  "publisher.datasetForm.chooser.apply": "Apply",
  "publisher.datasetForm.chooser.common": "Common licenses",
  "publisher.datasetForm.chooser.heading": "License chooser",
  "publisher.datasetForm.chooser.help": "Fills the SPDX identifier and URL below. Pick a common license, or use the guided chooser — dedicating to the public domain? Choose CC0.",
  "publisher.datasetForm.chooser.hide": "Hide chooser",
  "publisher.datasetForm.chooser.prompt": "Answer both questions to see a suggested license.",
  "publisher.datasetForm.chooser.q1": "Allow others to adapt or remix your work?",
  "publisher.datasetForm.chooser.q1.no": "No",
  "publisher.datasetForm.chooser.q1.sharealike": "Yes, share-alike",
  "publisher.datasetForm.chooser.q1.yes": "Yes",
  "publisher.datasetForm.chooser.q2": "Allow commercial use of your work?",
  "publisher.datasetForm.chooser.q2.no": "No",
  "publisher.datasetForm.chooser.q2.yes": "Yes",
  "publisher.datasetForm.chooser.quickPick": "Quick pick",
  "publisher.datasetForm.chooser.show": "Show chooser",
  "publisher.datasetForm.chooser.suggested": "Suggested license",
  "publisher.datasetForm.dataUpload.heading": "Dataset data",
  "publisher.datasetForm.datetime.date": "Date",
  "publisher.datasetForm.datetime.time": "Time (24h)",
  "publisher.datasetForm.deferredHint": "Recommended fields (abstract, organization, license, time range, categories, keywords) ship in sub-phase 3pc/C. Drafts can be saved with the required fields only.",
  "publisher.datasetForm.encoding.colorScaleInvalid": "This is not a valid colour scale. It needs at least two stops and a vmin and vmax that differ.",
  "publisher.datasetForm.encoding.colorScaleLabel": "Colour scale (JSON)",
  "publisher.datasetForm.encoding.colorScalePlaceholder": "Paste the color_scale.json produced alongside the video",
  "publisher.datasetForm.encoding.colorScaleReadable": "Viewers see this as {vmin} to {vmax} {units} — the same values, restated so the legend reads without leading zeros.",
  "publisher.datasetForm.encoding.colorScaleRequired": "A colour scale is required for a data-encoded video — without it the values cannot be read back.",
  "publisher.datasetForm.encoding.colorScaleValid": "Valid: {stops} stops, {vmin} to {vmax} {units}.",
  "publisher.datasetForm.encoding.dataEncodedHelp": "Choose this before uploading. Brightness carries the measured value rather than a colour, so the globe can show real numbers on hover and you can re-colour the dataset without re-encoding it. Changing this after the video is processed will not re-process it.",
  "publisher.datasetForm.encoding.dataEncodedLabel": "This video encodes data, not a picture",
  "publisher.datasetForm.encoding.legend": "Video encoding",
  "publisher.datasetForm.encoding.uploadBlocked": "Add a valid colour scale above before uploading. The video is processed differently for data, and that choice is read when the upload starts — uploading first would lose the values.",
  "publisher.datasetForm.encoding.uploadNeedsSave": "Save the dataset before uploading. The video is processed using the encoding stored on the dataset, and this change has not been saved yet.",
  "publisher.datasetForm.field.abstract": "Abstract",
  "publisher.datasetForm.field.attribution": "Attribution",
  "publisher.datasetForm.field.bboxE": "East",
  "publisher.datasetForm.field.bboxN": "North",
  "publisher.datasetForm.field.bboxS": "South",
  "publisher.datasetForm.field.bboxW": "West",
  "publisher.datasetForm.field.boundingBox": "Bounding box (°)",
  "publisher.datasetForm.field.celestialBody": "Celestial body",
  "publisher.datasetForm.field.citation": "Citation",
  "publisher.datasetForm.field.dataRef": "Data reference",
  "publisher.datasetForm.field.dataRefManual": "Data reference (manual override)",
  "publisher.datasetForm.field.doi": "DOI",
  "publisher.datasetForm.field.endTime": "End time",
  "publisher.datasetForm.field.flippedInY": "Flip vertically (inverted-Y imagery)",
  "publisher.datasetForm.field.format": "Format",
  "publisher.datasetForm.field.keywords": "Keywords",
  "publisher.datasetForm.field.legend": "Legend image",
  "publisher.datasetForm.field.legendManual": "Legend reference (manual)",
  "publisher.datasetForm.field.licenseSpdx": "License (SPDX)",
  "publisher.datasetForm.field.licenseStatement": "License statement",
  "publisher.datasetForm.field.licenseUrl": "License URL",
  "publisher.datasetForm.field.lonOrigin": "Longitude origin (°)",
  "publisher.datasetForm.field.organization": "Organization",
  "publisher.datasetForm.field.period": "Period",
  "publisher.datasetForm.field.playbackFps": "Playback rate (frames/sec)",
  "publisher.datasetForm.field.radiusMi": "Radius (miles)",
  "publisher.datasetForm.field.rightsHolder": "Rights holder",
  "publisher.datasetForm.field.slug": "Slug",
  "publisher.datasetForm.field.startTime": "Start time",
  "publisher.datasetForm.field.tags": "Tags",
  "publisher.datasetForm.field.thumbnail": "Thumbnail image",
  "publisher.datasetForm.field.thumbnailManual": "Thumbnail reference (manual)",
  "publisher.datasetForm.field.title": "Title",
  "publisher.datasetForm.field.visibility": "Visibility",
  "publisher.datasetForm.format.imageJpeg": "JPEG image",
  "publisher.datasetForm.format.imagePng": "PNG image",
  "publisher.datasetForm.format.imageWebp": "WebP image",
  "publisher.datasetForm.format.tour": "Tour (SOS JSON)",
  "publisher.datasetForm.format.video": "Video (MP4)",
  "publisher.datasetForm.headingEdit": "Edit dataset",
  "publisher.datasetForm.headingNew": "New dataset",
  "publisher.datasetForm.help.abstract": "Markdown supported. Headings (##, ###), **bold**, *italic*, lists, code, blockquotes, links.",
  "publisher.datasetForm.help.boundingBox": "Optional. The data's geographic extent — fill all four corners to clip the data to a region over a base Earth; leave blank for a full-globe (equirectangular) dataset. North ≥ South; N/S in [-90, 90], W/E in [-180, 180].",
  "publisher.datasetForm.help.celestialBody": "Optional. The body the data visualises (Earth, Mars, Moon, Sun…). Blank means Earth.",
  "publisher.datasetForm.help.dataRefManual": "Optional. Use this to swap the row to a legacy `vimeo:` / `url:` reference or paste an existing `r2:videos/.../master.m3u8` path without re-uploading bytes. The uploader above is the normal path for new content.",
  "publisher.datasetForm.help.flippedInY": "Check if the source imagery is authored with an inverted (top-to-bottom) Y axis.",
  "publisher.datasetForm.help.geography": "The globe expects equirectangular (plate carrée, EPSG:4326) imagery. Reproject other map projections first — e.g. `gdalwarp -t_srs EPSG:4326` — or render the data through a Zyra workflow.",
  "publisher.datasetForm.help.keywords": "Press Enter or comma to add. Max 20 keywords, 40 characters each.",
  "publisher.datasetForm.help.legend": "Optional. PNG, JPEG, or WebP — the colour-scale legend shown alongside the loaded dataset. Upload one above, or paste an `r2:` / absolute HTTPS reference.",
  "publisher.datasetForm.help.licenseSpdx": "SPDX identifier (e.g., CC0-1.0, CC-BY-4.0). One of SPDX or License statement is required before publishing.",
  "publisher.datasetForm.help.lonOrigin": "Optional. Degrees offset for the longitude axis: 0 = prime-meridian centred, ±180 = dateline centred.",
  "publisher.datasetForm.help.period": "ISO 8601 duration: P1D (daily), PT1H (hourly), P1M (monthly), PT15M (every 15 minutes).",
  "publisher.datasetForm.help.playbackFps": "Optional, image-sequence datasets only. How many source frames play per second — 1 holds each frame for a second. Blank uses the catalog default (30), which plays a short sequence in under a second. Changing this re-encodes the whole video.",
  "publisher.datasetForm.help.radiusMi": "Optional. Radius of the celestial body in miles (pair with a non-Earth body for proportional sizing).",
  "publisher.datasetForm.help.slug": "Auto-derived from the title; edit to customise. Must start with a letter and use lowercase letters, digits, and hyphens only.",
  "publisher.datasetForm.help.slugPublished": "Locked — this is the dataset's public web address, and changing it would break links people have already shared. Slugs are editable while a dataset is still a draft.",
  "publisher.datasetForm.help.tags": "Press Enter or comma to add. Free-form labels — use for what categories and keywords don't already cover.",
  "publisher.datasetForm.help.thumbnail": "Optional. PNG, JPEG, or WebP — the image shown on the browse card. Upload one above, or paste an `r2:` / absolute HTTPS reference.",
  "publisher.datasetForm.help.timeRange": "Times entered in your local timezone are stored as UTC. Set both Start and End together (or neither); the publish-readiness check enforces start ≤ end.",
  "publisher.datasetForm.nav.aria": "Form sections",
  "publisher.datasetForm.placeholder.abstract": "Monthly mean sea-surface temperature anomaly relative to the 1991-2020 climatology. Generated by Zyra workflow `sst-anomaly-monthly`.",
  "publisher.datasetForm.placeholder.dataRef": "vimeo:1234567",
  "publisher.datasetForm.placeholder.keywords": "sst, anomaly, monthly",
  "publisher.datasetForm.placeholder.licenseStatement": "Public domain / U.S. Government. May be reproduced without permission.",
  "publisher.datasetForm.placeholder.tags": "demo, featured",
  "publisher.datasetForm.placeholder.title": "Sea Surface Temperature Anomaly — April 2026",
  "publisher.datasetForm.preview.empty": "Nothing to preview yet. Switch back to Edit and write some markdown.",
  "publisher.datasetForm.readiness.abstract": "Abstract",
  "publisher.datasetForm.readiness.count": "{ready} of {total} ready",
  "publisher.datasetForm.readiness.dataRef": "Data reference",
  "publisher.datasetForm.readiness.format": "Format",
  "publisher.datasetForm.readiness.heading": "Publish readiness",
  "publisher.datasetForm.readiness.license": "License (SPDX or statement)",
  "publisher.datasetForm.readiness.notReadyAria": "not ready",
  "publisher.datasetForm.readiness.readyAria": "ready",
  "publisher.datasetForm.readiness.title": "Title",
  "publisher.datasetForm.requiredAria": "required",
  "publisher.datasetForm.section.abstract": "Abstract",
  "publisher.datasetForm.section.categorization": "Categorization",
  "publisher.datasetForm.section.geography": "Geography & projection",
  "publisher.datasetForm.section.identity": "Identity",
  "publisher.datasetForm.section.licensing": "Licensing & attribution",
  "publisher.datasetForm.section.media": "Media",
  "publisher.datasetForm.section.timeRange": "Time range",
  "publisher.datasetForm.section.timeSpace": "Time & space",
  "publisher.datasetForm.transcoding.notice": "A video transcode is in progress for this row. Reload this page or open the dataset's detail view to see when it finishes — typically 1–10 minutes depending on the source length. Changes to the data reference can't be saved while a transcode is running.",
  "publisher.datasetForm.visibility.federated": "Federated",
  "publisher.datasetForm.visibility.private": "Private",
  "publisher.datasetForm.visibility.public": "Public",
  "publisher.datasetForm.visibility.restricted": "Restricted",
  "publisher.datasets.action.delete": "Delete",
  "publisher.datasets.action.delete.aria": "Delete dataset {title}",
  "publisher.datasets.action.edit": "Edit",
  "publisher.datasets.action.edit.aria": "Edit dataset {title}",
  "publisher.datasets.action.retract": "Retract",
  "publisher.datasets.action.retract.aria": "Retract dataset {title}",
  "publisher.datasets.action.view": "View",
  "publisher.datasets.action.view.aria": "View dataset {title}",
  "publisher.datasets.col.actions": "Actions",
  "publisher.datasets.col.format": "Format",
  "publisher.datasets.col.slug": "Slug",
  "publisher.datasets.col.thumbnail": "Preview",
  "publisher.datasets.col.title": "Title",
  "publisher.datasets.col.updated": "Updated",
  "publisher.datasets.count.filtered": "{shown} of {total} shown",
  "publisher.datasets.count.one": "{count} dataset",
  "publisher.datasets.count.other": "{count} datasets",
  "publisher.datasets.delete.confirm": "Delete “{title}” permanently? Its uploaded assets are removed too. Published datasets must be retracted first.",
  "publisher.datasets.delete.failed": "Delete failed — the dataset may be published or mid-transcode.",
  "publisher.datasets.empty.drafts": "No drafts yet. Click \"+ New draft\" to create one, or use the terraviz CLI.",
  "publisher.datasets.empty.published": "No published datasets yet.",
  "publisher.datasets.empty.retracted": "No retracted datasets.",
  "publisher.datasets.loadMore": "Load more",
  "publisher.datasets.loading": "Loading datasets…",
  "publisher.datasets.loadingMore": "Loading…",
  "publisher.datasets.newDraft": "+ New draft",
  "publisher.datasets.retract.confirm": "Retract “{title}”? It will no longer appear on the globe until you publish it again.",
  "publisher.datasets.retract.failed": "Retract failed",
  "publisher.datasets.search.aria": "Search datasets by title or slug",
  "publisher.datasets.search.noMatch": "No datasets match “{query}”.",
  "publisher.datasets.search.placeholder": "Search datasets by title or slug…",
  "publisher.datasets.status.draft": "Draft",
  "publisher.datasets.status.published": "Published",
  "publisher.datasets.status.retracted": "Retracted",
  "publisher.datasets.subtitle": "The visualizations you publish to the globe.",
  "publisher.datasets.tab.drafts": "Drafts",
  "publisher.datasets.tab.published": "Published",
  "publisher.datasets.tab.retracted": "Retracted",
  "publisher.datasets.tabs.aria": "Dataset lifecycle filter",
  "publisher.datasets.title": "Datasets",
  "publisher.error.detailsSummary": "Server response",
  "publisher.error.statusLine": "HTTP {status}",
  "publisher.events.addDataset": "Add dataset",
  "publisher.events.approve": "Approve",
  "publisher.events.bulkApprove": "Approve all ≥{threshold}% · {count}",
  "publisher.events.bulkApproved": "Paired {count} datasets",
  "publisher.events.decision.prompt": "Surface this event?",
  "publisher.events.detailLabel": "Detail",
  "publisher.events.drawer.addAria": "Pair {title}",
  "publisher.events.drawer.close": "Close",
  "publisher.events.drawer.eventEyebrow": "The event",
  "publisher.events.drawer.heading": "New event",
  "publisher.events.drawer.noResults": "No datasets match that search.",
  "publisher.events.drawer.pairEyebrow": "Pair datasets",
  "publisher.events.drawer.pairedCount": "{count} paired",
  "publisher.events.drawer.removeAria": "Unpair {title}",
  "publisher.events.drawer.save": "Create event",
  "publisher.events.drawer.searchAria": "Search the catalog to pair datasets",
  "publisher.events.drawer.searchHint": "Search the catalog to pair datasets with this event.",
  "publisher.events.drawer.searchPlaceholder": "Search catalog…",
  "publisher.events.edit": "Edit date / location",
  "publisher.events.edit.date": "Occurred date",
  "publisher.events.edit.invalidPoint": "Enter coordinates as latitude, longitude (e.g. 37.2, -76.8).",
  "publisher.events.edit.location": "Location",
  "publisher.events.edit.locationHint": "Start typing a region name…",
  "publisher.events.edit.point": "Coordinates (optional)",
  "publisher.events.edit.save": "Save",
  "publisher.events.empty": "No events to review right now.",
  "publisher.events.error.generic": "Could not save. Please try again.",
  "publisher.events.error.session": "Your session expired. Please sign in again.",
  "publisher.events.filter.all": "All",
  "publisher.events.filter.label": "Filter by status",
  "publisher.events.form.cancel": "Cancel",
  "publisher.events.form.created": "Event created.",
  "publisher.events.form.createdIn": "Event created. Showing {bucket}.",
  "publisher.events.form.error": "Couldn't create the event. Check the fields and try again.",
  "publisher.events.form.heading": "Create an event by hand",
  "publisher.events.form.keywords": "Keywords (comma-separated, optional)",
  "publisher.events.form.occurredEnd": "End time (optional)",
  "publisher.events.form.occurredStart": "Start time (optional)",
  "publisher.events.form.region": "Region or place (optional)",
  "publisher.events.form.sourceName": "Source name",
  "publisher.events.form.sourceUrl": "Source URL",
  "publisher.events.form.submit": "Create event",
  "publisher.events.form.summary": "Summary (optional)",
  "publisher.events.form.title": "Title",
  "publisher.events.generateTour": "Generate tour",
  "publisher.events.generateTour.working": "Generating tour draft…",
  "publisher.events.inferred.date": "date",
  "publisher.events.inferred.label": "AI-inferred",
  "publisher.events.inferred.location": "location",
  "publisher.events.inferred.tooltip": "These fields were extracted by AI from the headline and summary — double-check them before approving.",
  "publisher.events.intro": "Vet proposed current events and the datasets they relate to. Approving an event surfaces it; approving a link confirms that dataset pairing.",
  "publisher.events.links": "Related datasets",
  "publisher.events.loading": "Loading…",
  "publisher.events.match": "Match",
  "publisher.events.match.compositeAria": "Overall match {value} out of 100",
  "publisher.events.match.compositeNa": "Overall match not available",
  "publisher.events.match.facetAria": "{facet} {value} out of 100",
  "publisher.events.match.facetNa": "{facet} not available",
  "publisher.events.match.geoAbbr": "G",
  "publisher.events.match.timeAbbr": "Ti",
  "publisher.events.match.topicAbbr": "T",
  "publisher.events.new": "New event",
  "publisher.events.noLinks": "No proposed dataset links.",
  "publisher.events.occurred": "When",
  "publisher.events.pairing.approveAria": "Approve {title} pairing",
  "publisher.events.pairing.rejectAria": "Reject {title} pairing",
  "publisher.events.query.allCategories": "All categories",
  "publisher.events.query.allSources": "All sources",
  "publisher.events.query.aria": "Event filters",
  "publisher.events.query.category": "Category",
  "publisher.events.query.clear": "Clear filters",
  "publisher.events.query.count.filtered": "{shown} of {total} shown",
  "publisher.events.query.count.one": "{count} event",
  "publisher.events.query.count.other": "{count} events",
  "publisher.events.query.noMatch": "No events match these filters.",
  "publisher.events.query.nowShowing": "Now showing {title}.",
  "publisher.events.query.option": "{name} ({count})",
  "publisher.events.query.search": "Search",
  "publisher.events.query.searchPlaceholder": "Title, summary, keywords, place…",
  "publisher.events.query.sort": "Sort",
  "publisher.events.query.sort.bestMatch": "Strongest dataset match",
  "publisher.events.query.sort.mostToReview": "Most datasets to review",
  "publisher.events.query.sort.newest": "Newest first",
  "publisher.events.query.sort.oldest": "Oldest first",
  "publisher.events.query.source": "Source",
  "publisher.events.query.truncated": "Only the newest {loaded} of {total} events are loaded. Search, filters and sorting work on those alone, so older events won’t appear.",
  "publisher.events.queue.aria": "Event queue",
  "publisher.events.queue.eyebrow": "Proposed events",
  "publisher.events.queue.rowAria": "{title}, {source}, {category}, {count} datasets to review",
  "publisher.events.queue.toReview": "{count} datasets to review",
  "publisher.events.queue.uncategorized": "uncategorized",
  "publisher.events.readonly.notice": "You have view-only access to this event — only its owner can review or edit it.",
  "publisher.events.refresh": "Refresh feed",
  "publisher.events.refreshError": "Couldn't reach the feed. Please try again.",
  "publisher.events.refreshResult": "Imported {created} new · {refreshed} refreshed · {failed} skipped.",
  "publisher.events.refreshing": "Refreshing…",
  "publisher.events.reject": "Reject",
  "publisher.events.saved": "Saved.",
  "publisher.events.signal.geo": "Geo",
  "publisher.events.signal.temporal": "Time",
  "publisher.events.signal.topic": "Topic",
  "publisher.events.source": "Source",
  "publisher.events.status.approved": "Approved",
  "publisher.events.status.expired": "Expired",
  "publisher.events.status.proposed": "Proposed",
  "publisher.events.status.rejected": "Rejected",
  "publisher.events.storyImage.alt": "Image from the cited story",
  "publisher.events.subtitle": "Review proposed current events and confirm the datasets they pair with.",
  "publisher.events.suggest.altPlaceholder": "Describe the image (alt text)",
  "publisher.events.suggest.commons": "Nearby photo — public domain",
  "publisher.events.suggest.commonsAlt": "Freely licensed photo taken near the event location",
  "publisher.events.suggest.nhc": "Forecast cone — public domain",
  "publisher.events.suggest.nhcAlt": "National Hurricane Center forecast cone for this storm",
  "publisher.events.suggest.removeVideo": "Remove video",
  "publisher.events.suggest.replacePhoto": "Replace photo",
  "publisher.events.suggest.shakemap": "Shaking intensity — public domain",
  "publisher.events.suggest.shakemapAlt": "USGS ShakeMap shaking-intensity map for this earthquake",
  "publisher.events.suggest.title": "Suggested media",
  "publisher.events.suggest.uploadPhoto": "Upload photo",
  "publisher.events.suggest.use": "Use as event image",
  "publisher.events.suggest.useVideo": "Use as event video",
  "publisher.events.suggest.videoAttached": "Attached event video",
  "publisher.events.suggest.videoSitemap": "Video — agency source",
  "publisher.events.suggest.videoSitemapAlt": "Video thumbnail from a registered agency video source",
  "publisher.events.suggest.worldview": "Satellite view — public domain",
  "publisher.events.suggest.worldviewAlt": "Satellite imagery of the event location on its date",
  "publisher.events.suggest.youtube": "Video",
  "publisher.events.suggest.youtubeAlt": "Video thumbnail from a vetted YouTube channel",
  "publisher.events.title": "Events",
  "publisher.feature.analytics": "Analytics",
  "publisher.feature.blog": "Blog",
  "publisher.feature.datasets": "Datasets",
  "publisher.feature.events": "Events",
  "publisher.feature.feedback": "Feedback",
  "publisher.feature.hero": "“Right now” hero",
  "publisher.feature.orbit": "Orbit (AI docent)",
  "publisher.feature.tours": "Tours",
  "publisher.feature.workflows": "Workflows",
  "publisher.featureDisabled.body": "An admin has turned the {feature} feature off for this node. It can be re-enabled from Node profile.",
  "publisher.featureDisabled.title": "{feature} is turned off",
  "publisher.feedback.ai.comment": "Comment",
  "publisher.feedback.ai.negative": "Negative",
  "publisher.feedback.ai.negativePerDay": "Negative per day",
  "publisher.feedback.ai.positive": "Positive",
  "publisher.feedback.ai.positivePerDay": "Positive per day",
  "publisher.feedback.ai.rating": "Rating",
  "publisher.feedback.ai.satisfaction": "Satisfaction",
  "publisher.feedback.ai.topTags": "Tags",
  "publisher.feedback.ai.total": "Total ratings",
  "publisher.feedback.ai.userMessage": "User message",
  "publisher.feedback.dataset": "Dataset",
  "publisher.feedback.date": "Date",
  "publisher.feedback.detail.appState": "App state",
  "publisher.feedback.detail.appVersion": "App version",
  "publisher.feedback.detail.assistantResponse": "Assistant response",
  "publisher.feedback.detail.close": "Close",
  "publisher.feedback.detail.country": "Country",
  "publisher.feedback.detail.llm": "LLM",
  "publisher.feedback.detail.localEngine": "Local engine (fallback)",
  "publisher.feedback.detail.model": "Model",
  "publisher.feedback.detail.openFullSize": "Open full size",
  "publisher.feedback.detail.platform": "Platform",
  "publisher.feedback.detail.reporter": "Reporter",
  "publisher.feedback.detail.source": "Source",
  "publisher.feedback.detail.status": "Status",
  "publisher.feedback.detail.url": "URL",
  "publisher.feedback.empty": "No feedback yet.",
  "publisher.feedback.exportCsv": "Export CSV",
  "publisher.feedback.exportJsonl": "Export JSONL",
  "publisher.feedback.general.bugs": "Bugs",
  "publisher.feedback.general.bugsPerDay": "Bugs per day",
  "publisher.feedback.general.contact": "Contact",
  "publisher.feedback.general.content": "Content",
  "publisher.feedback.general.contentPerDay": "Content reports per day",
  "publisher.feedback.general.features": "Features",
  "publisher.feedback.general.featuresPerDay": "Feature requests per day",
  "publisher.feedback.general.ideas": "Ideas",
  "publisher.feedback.general.ideasPerDay": "Ideas per day",
  "publisher.feedback.general.kind": "Kind",
  "publisher.feedback.general.message": "Message",
  "publisher.feedback.general.other": "Other",
  "publisher.feedback.general.otherPerDay": "Other per day",
  "publisher.feedback.general.rating": "Rating",
  "publisher.feedback.general.ratingValue": "{rating} / 5",
  "publisher.feedback.general.screenshot": "Screenshot",
  "publisher.feedback.general.screenshotAlt": "User-attached screenshot",
  "publisher.feedback.general.screenshotFailed": "Could not load the screenshot.",
  "publisher.feedback.general.screenshotLabel": "Screenshot",
  "publisher.feedback.general.total": "Total",
  "publisher.feedback.loading": "Loading feedback…",
  "publisher.feedback.subtitle": "What visitors tell you — Orbit's AI ratings and general bug reports.",
  "publisher.feedback.tab.ai": "AI feedback",
  "publisher.feedback.tab.general": "General feedback",
  "publisher.feedback.tabsAria": "Feedback views",
  "publisher.feedback.tags.all": "All",
  "publisher.feedback.tags.aria": "Filter feedback by tag",
  "publisher.feedback.title": "Feedback",
  "publisher.feeds.add": "Add",
  "publisher.feeds.addedBadge": "Added ✓",
  "publisher.feeds.category.hazards": "Natural hazards",
  "publisher.feeds.category.news": "General news",
  "publisher.feeds.category.other": "Other",
  "publisher.feeds.category.scienceNews": "Science news",
  "publisher.feeds.channels.add": "Add channel",
  "publisher.feeds.channels.builtin": "Built-in",
  "publisher.feeds.channels.builtinDisabled": "Built-in · disabled",
  "publisher.feeds.channels.disable": "Disable",
  "publisher.feeds.channels.enable": "Enable",
  "publisher.feeds.channels.intro": "Event media suggestions include video from these vetted YouTube channels. Add your own by pasting a channel URL, or disable a built-in channel to drop it from suggestions (and save search quota).",
  "publisher.feeds.channels.invalid": "Paste a YouTube channel URL.",
  "publisher.feeds.channels.remove": "Remove",
  "publisher.feeds.channels.title": "Trusted video channels",
  "publisher.feeds.channels.unavailable": "Media-channel management isn't available on this deployment.",
  "publisher.feeds.channels.url": "Channel URL",
  "publisher.feeds.custom.add": "Add feed",
  "publisher.feeds.custom.category": "Category",
  "publisher.feeds.custom.category.hint": "Pick a suggested category or type your own — it groups this feed and is offered again next time.",
  "publisher.feeds.custom.category.placeholder": "Pick or type a category",
  "publisher.feeds.custom.intro": "Point at any RSS or Atom feed. Items arrive as proposed events for review — nothing surfaces publicly without your approval.",
  "publisher.feeds.custom.invalid": "Enter a name and an http(s) feed URL.",
  "publisher.feeds.custom.label": "Name",
  "publisher.feeds.custom.title": "Add your own feed",
  "publisher.feeds.custom.url": "Feed URL",
  "publisher.feeds.empty": "No feeds registered.",
  "publisher.feeds.error.generic": "Something went wrong. Try again.",
  "publisher.feeds.error.run": "The feed run failed. Try again.",
  "publisher.feeds.error.session": "Your session expired — sign in again.",
  "publisher.feeds.intro": "The feeds this node ingests current events from. Every ingested event lands in the review queue as proposed.",
  "publisher.feeds.lastRun.error": "last run failed — {detail}",
  "publisher.feeds.lastRun.never": "never run",
  "publisher.feeds.lastRun.ok": "last ran {when}",
  "publisher.feeds.loading": "Loading feeds…",
  "publisher.feeds.pageSubtitle": "The sources that turn current events into proposed items in your Events queue.",
  "publisher.feeds.pageTitle": "Feeds",
  "publisher.feeds.pause": "Pause",
  "publisher.feeds.preset.bbc": "BBC's science and environment desk.",
  "publisher.feeds.preset.cams": "Air-quality and atmosphere monitoring news from Copernicus.",
  "publisher.feeds.preset.copernicus": "News from the EU's Earth-observation programme.",
  "publisher.feeds.preset.eonet": "Curated natural events (storms, wildfires, volcanoes) with location and time built in.",
  "publisher.feeds.preset.esaEarth": "ESA's Earth-observation newsroom.",
  "publisher.feeds.preset.eumetsat": "Europe's meteorological-satellite operator newsroom.",
  "publisher.feeds.preset.gdacs": "Global disaster alerts (floods, cyclones, quakes) with coordinates.",
  "publisher.feeds.preset.guardian": "The Guardian's environment section.",
  "publisher.feeds.preset.gvp": "Weekly volcanic-activity reports from the Global Volcanism Program.",
  "publisher.feeds.preset.nasaEo": "Stories and imagery about Earth from NASA's Earth Observatory.",
  "publisher.feeds.preset.nasaNews": "NASA's breaking news releases.",
  "publisher.feeds.preset.nhcAtlantic": "Active Atlantic hurricane and tropical-storm advisories.",
  "publisher.feeds.preset.nhcEpacific": "Active East Pacific hurricane and tropical-storm advisories.",
  "publisher.feeds.preset.noaaNews": "NOAA's newsroom — oceans, weather, climate, fisheries.",
  "publisher.feeds.preset.nwsSevere": "Live severe and extreme weather alerts across the United States.",
  "publisher.feeds.preset.nyt": "The New York Times climate desk.",
  "publisher.feeds.preset.physorg": "Earth-science research news aggregator.",
  "publisher.feeds.preset.ptwc": "Pacific tsunami warnings and advisories, with coordinates.",
  "publisher.feeds.preset.reliefweb": "UN-run humanitarian disaster tracking worldwide.",
  "publisher.feeds.preset.sciencedaily": "Earth & climate research summaries.",
  "publisher.feeds.preset.usgsQuakes": "Significant earthquakes with precise time and coordinates.",
  "publisher.feeds.preview": "Preview",
  "publisher.feeds.preview.empty": "No items found in this feed.",
  "publisher.feeds.preview.error": "Could not fetch this feed.",
  "publisher.feeds.preview.hide": "Hide preview",
  "publisher.feeds.preview.invalidUrl": "Enter an http(s) feed URL to preview.",
  "publisher.feeds.preview.loading": "Fetching the latest items…",
  "publisher.feeds.rematch.action": "Re-score events now",
  "publisher.feeds.rematch.done": "Re-scored {rescored} of {scanned} events. {failed} failed.",
  "publisher.feeds.rematch.error": "Could not re-score events.",
  "publisher.feeds.rematch.errorResumable": "Stopped after {scanned} events — the rest are still to do. Run it again to continue from there.",
  "publisher.feeds.rematch.intro": "Events are scored against the catalog when they arrive, and again if you edit their date or location. After a scoring change, events their feed has already dropped keep the old scores until you re-score them here. Safe to run at any time; it never changes a pairing you have approved or rejected.",
  "publisher.feeds.rematch.partial": "Stopped after re-scoring {rescored} of {scanned} events ({failed} failed). Run again to continue.",
  "publisher.feeds.rematch.progress": "Re-scoring… {scanned} events so far.",
  "publisher.feeds.rematch.running": "Re-scoring…",
  "publisher.feeds.rematch.title": "Re-score events",
  "publisher.feeds.remove": "Remove",
  "publisher.feeds.restricted": "Managing feeds is restricted to admin publishers.",
  "publisher.feeds.resume": "Resume",
  "publisher.feeds.runDone": "Ingest complete — {created} new, {refreshed} refreshed, {failed} failed.",
  "publisher.feeds.runNow": "Run all enabled feeds now",
  "publisher.feeds.running": "Fetching feeds…",
  "publisher.feeds.suggested": "Suggested feeds",
  "publisher.feeds.tab.media": "Media channels",
  "publisher.feeds.tab.news": "News feeds",
  "publisher.feeds.title": "Current-events feeds",
  "publisher.feeds.videoSources.add": "Add video source",
  "publisher.feeds.videoSources.addTitle": "Add a video sitemap",
  "publisher.feeds.videoSources.attribution": "Attribution (optional)",
  "publisher.feeds.videoSources.empty": "No video sources yet. Add an agency video sitemap below.",
  "publisher.feeds.videoSources.indexDone": "Indexed {indexed} video(s), embedded {embedded}.",
  "publisher.feeds.videoSources.indexError": "Indexing failed. Try again shortly.",
  "publisher.feeds.videoSources.indexNow": "Index now",
  "publisher.feeds.videoSources.indexing": "Indexing videos…",
  "publisher.feeds.videoSources.intro": "Registered video sitemaps (e.g. NOAA Ocean Today). Their videos become topic-matched suggestions in the events and blog editors — nothing is published automatically.",
  "publisher.feeds.videoSources.invalid": "A label and an http(s) sitemap URL are required.",
  "publisher.feeds.videoSources.label": "Label",
  "publisher.feeds.videoSources.lastRun.ok": "Indexed {when} · {count} video(s)",
  "publisher.feeds.videoSources.title": "Agency video sources",
  "publisher.feeds.videoSources.url": "Sitemap URL",
  "publisher.hero.clear": "Clear hero",
  "publisher.hero.cleared": "Hero cleared.",
  "publisher.hero.dataset": "Dataset",
  "publisher.hero.error.generic": "Could not save. Please try again.",
  "publisher.hero.error.noDataset": "Pick a dataset to feature.",
  "publisher.hero.error.session": "Your session expired. Please sign in again.",
  "publisher.hero.error.window": "Set a start and end, with the start before the end.",
  "publisher.hero.headline": "Headline (optional)",
  "publisher.hero.intro": "Pin one dataset as the catalog's “Right now” hero for the chosen window. Leave it unset to fall back to an auto-derived real-time dataset.",
  "publisher.hero.loading": "Loading…",
  "publisher.hero.pickDataset": "Select a dataset…",
  "publisher.hero.preview": "Preview · catalog card",
  "publisher.hero.readonly.current": "Currently featured",
  "publisher.hero.readonly.headline": "Headline: {headline}",
  "publisher.hero.readonly.none": "No dataset is currently featured. The catalog falls back to an auto-derived real-time dataset.",
  "publisher.hero.readonly.notice": "You have view-only access. Only editors and admins can change the featured hero.",
  "publisher.hero.readonly.window": "Active {start} – {end}",
  "publisher.hero.saved": "Hero set.",
  "publisher.hero.set": "Set hero",
  "publisher.hero.title": "“Right now” hero",
  "publisher.hero.windowEnd": "End",
  "publisher.hero.windowStart": "Start",
  "publisher.import.attachWorkflow.hint": "Optional. Keeps imported datasets current.",
  "publisher.import.attachWorkflow.label": "Attach refresh workflow",
  "publisher.import.attachWorkflow.none": "None",
  "publisher.import.cli.body": "For large or recurring imports, script them with the terraviz CLI:",
  "publisher.import.cli.copied": "Copied ✓",
  "publisher.import.cli.copy": "Copy",
  "publisher.import.col.format": "Format",
  "publisher.import.col.slug": "Slug",
  "publisher.import.col.status": "Status",
  "publisher.import.col.title": "Title",
  "publisher.import.defaultVisibility.hint": "Applied to rows that don't specify one.",
  "publisher.import.defaultVisibility.label": "Default visibility",
  "publisher.import.drop.browse": "Browse files…",
  "publisher.import.drop.hint": "CSV or JSON · one row per dataset · up to {max} rows",
  "publisher.import.drop.prompt": "Drop a manifest here, or browse",
  "publisher.import.drop.template": "Download template",
  "publisher.import.issue.badSlug": "Slug has invalid characters",
  "publisher.import.issue.noDataRef": "No data reference — will import as draft",
  "publisher.import.issue.noFormat": "Missing or unrecognized format",
  "publisher.import.issue.noLicense": "No license — will import as draft",
  "publisher.import.issue.noTitle": "Missing title — required",
  "publisher.import.issue.tooMany": "Beyond the {max}-row limit — this row will be skipped",
  "publisher.import.method.cli.desc": "Script large or recurring imports with the terraviz CLI.",
  "publisher.import.method.cli.title": "Command line",
  "publisher.import.method.manifest.desc": "Upload a CSV or JSON manifest describing many datasets at once.",
  "publisher.import.method.manifest.title": "Manifest file",
  "publisher.import.method.remote.desc": "Pull published datasets from another federated Terraviz node.",
  "publisher.import.method.remote.title": "Remote node",
  "publisher.import.parse.badJson": "Couldn't parse that file as CSV or JSON.",
  "publisher.import.parse.empty": "That file has no data rows.",
  "publisher.import.parse.unknownCols": "No recognizable columns found (need at least a title).",
  "publisher.import.preview.error": "{count} error",
  "publisher.import.preview.heading": "Preview",
  "publisher.import.preview.ready": "{count} ready",
  "publisher.import.preview.warning": "{count} warning",
  "publisher.import.remote.body": "Federated node-to-node import arrives with Phase 4 federation. You'll paste a remote node URL and choose which published datasets to pull in as drafts.",
  "publisher.import.remote.comingSoon": "Coming with federation",
  "publisher.import.restricted": "Importing datasets needs a role that can create content (contributor, author, editor, or admin). Your reviewer role has read-only access — contact an admin if you need to import.",
  "publisher.import.status.error": "Error",
  "publisher.import.status.ready": "Ready",
  "publisher.import.status.warning": "Warning",
  "publisher.import.submit": "Import {count} as drafts",
  "publisher.import.submit.pendingNote": "Bulk import runs server-side — this endpoint is on the way. The preview and validation above work today.",
  "publisher.import.submit.zero": "Import as drafts",
  "publisher.import.subtitle": "Bring many datasets into your catalog at once. Everything imports as drafts you review before publishing.",
  "publisher.import.title": "Import",
  "publisher.import.visibility.federated": "Federated",
  "publisher.import.visibility.private": "Private",
  "publisher.import.visibility.public": "Public",
  "publisher.import.visibility.restricted": "Restricted",
  "publisher.markdownToolbar.aria": "Markdown formatting",
  "publisher.markdownToolbar.blockquote.aria": "Blockquote",
  "publisher.markdownToolbar.blockquote.title": "Blockquote (prepends > to each selected line)",
  "publisher.markdownToolbar.bold.aria": "Bold",
  "publisher.markdownToolbar.bold.title": "Bold (wraps selection in **)",
  "publisher.markdownToolbar.codeBlock.aria": "Code block",
  "publisher.markdownToolbar.codeBlock.title": "Code block (wraps selection in ``` fences)",
  "publisher.markdownToolbar.codeInline.aria": "Inline code",
  "publisher.markdownToolbar.codeInline.title": "Inline code (wraps selection in single backticks)",
  "publisher.markdownToolbar.h2.aria": "Heading",
  "publisher.markdownToolbar.h2.title": "Heading (prepends ## to each selected line)",
  "publisher.markdownToolbar.italic.aria": "Italic",
  "publisher.markdownToolbar.italic.title": "Italic (wraps selection in *)",
  "publisher.markdownToolbar.link.aria": "Link",
  "publisher.markdownToolbar.link.title": "Link (inserts [text](url) markdown)",
  "publisher.markdownToolbar.listBullet.aria": "Bullet list",
  "publisher.markdownToolbar.listBullet.title": "Bullet list (prepends - to each selected line)",
  "publisher.markdownToolbar.listNumbered.aria": "Numbered list",
  "publisher.markdownToolbar.listNumbered.title": "Numbered list (prepends 1. to each selected line)",
  "publisher.markdownToolbar.placeholder.bold": "bold text",
  "publisher.markdownToolbar.placeholder.code": "code",
  "publisher.markdownToolbar.placeholder.italic": "italic text",
  "publisher.markdownToolbar.placeholder.linkText": "text",
  "publisher.markdownToolbar.placeholder.linkUrl": "url",
  "publisher.me.affiliation.none": "Not set",
  "publisher.me.error.network": "Couldn't reach the server. Check your connection and try again.",
  "publisher.me.error.refresh": "Refresh",
  "publisher.me.error.server": "The server returned an error. Try again in a moment.",
  "publisher.me.error.session": "Your session has expired. Sign in to continue.",
  "publisher.me.error.signIn": "Sign in",
  "publisher.me.field.affiliation": "Affiliation",
  "publisher.me.field.email": "Email",
  "publisher.me.field.memberSince": "Member since",
  "publisher.me.field.role": "Role",
  "publisher.me.field.status": "Status",
  "publisher.me.heading": "Your publisher profile",
  "publisher.me.loading": "Loading your profile…",
  "publisher.me.role.admin": "Admin",
  "publisher.me.role.author": "Author",
  "publisher.me.role.contributor": "Contributor",
  "publisher.me.role.editor": "Editor",
  "publisher.me.role.reviewer": "Reviewer",
  "publisher.me.role.service": "Service",
  "publisher.me.status.active": "Active",
  "publisher.me.status.pending": "Pending approval",
  "publisher.me.status.suspended": "Suspended",
  "publisher.nav.account": "Account",
  "publisher.nav.analytics": "Analytics",
  "publisher.nav.aria": "Publisher portal sections",
  "publisher.nav.backToTerraviz": "Back to Terraviz",
  "publisher.nav.blog": "Blog",
  "publisher.nav.datasets": "Datasets",
  "publisher.nav.events": "Events",
  "publisher.nav.eventsBadge.aria": "{count} awaiting review",
  "publisher.nav.featuredHero": "Right now",
  "publisher.nav.feedback": "Feedback",
  "publisher.nav.feeds": "Feeds",
  "publisher.nav.group.catalog": "Catalog",
  "publisher.nav.group.insights": "Insights",
  "publisher.nav.group.newsroom": "Newsroom",
  "publisher.nav.group.settings": "Settings",
  "publisher.nav.import": "Import",
  "publisher.nav.nodeProfile": "Node profile",
  "publisher.nav.overview": "Overview",
  "publisher.nav.profile": "Profile",
  "publisher.nav.signOut": "Sign out",
  "publisher.nav.team": "Team",
  "publisher.nav.tours": "Tours",
  "publisher.nav.userMenu.aria": "Signed in as {name}",
  "publisher.nav.users": "Users",
  "publisher.nav.workflows": "Workflows",
  "publisher.nodeProfile.aboutMd": "About (markdown, optional)",
  "publisher.nodeProfile.aiCallout": "AI-assisted drafts in Blog and Tours ground themselves in this profile, so they speak in your organization's voice. Keep the mission and tone current.",
  "publisher.nodeProfile.defaultTone": "Default tone for generated drafts (optional)",
  "publisher.nodeProfile.embedding.access": "Embeds cannot load a page that Cloudflare Access protects. If Access covers the public app, other sites show a sign-in page or nothing.",
  "publisher.nodeProfile.embedding.error.duplicate": "This repeats {site}, listed above.",
  "publisher.nodeProfile.embedding.error.empty": "Enter a site, such as https://www.example.org.",
  "publisher.nodeProfile.embedding.error.fileForm": "Enter only {entry}, the word file followed by a colon, to allow pages opened from a file. That allows every such page, not only yours.",
  "publisher.nodeProfile.embedding.error.forbiddenChar": "A site cannot contain ; , quotes or other punctuation.",
  "publisher.nodeProfile.embedding.error.host": "Enter a valid host name, such as www.example.org.",
  "publisher.nodeProfile.embedding.error.ipOrSingleLabel": "Enter a full domain name, such as www.example.org. A single-word host or an IP address is refused.",
  "publisher.nodeProfile.embedding.error.keyword": "Enter a site address, not a policy keyword such as * or self.",
  "publisher.nodeProfile.embedding.error.notAscii": "Enter the punycode form (starting xn--) of an international domain name.",
  "publisher.nodeProfile.embedding.error.notHttps": "A site must start with https://.",
  "publisher.nodeProfile.embedding.error.path": "Enter only https:// and the host, with no path or trailing slash.",
  "publisher.nodeProfile.embedding.error.port": "A port must be a number from 1 to 65535.",
  "publisher.nodeProfile.embedding.error.required": "List at least one site, or choose \"No other site\".",
  "publisher.nodeProfile.embedding.error.sharedHost": "This wildcard covers sites anyone can create on that service. List your own sites one by one instead.",
  "publisher.nodeProfile.embedding.error.summary": "Some sites need fixing. Each one says why, under it. Fix them, then save again.",
  "publisher.nodeProfile.embedding.error.tooLong": "This is too long to be a site address.",
  "publisher.nodeProfile.embedding.error.tooMany": "List at most {max} sites.",
  "publisher.nodeProfile.embedding.error.userinfo": "Remove the user name or password before the host.",
  "publisher.nodeProfile.embedding.error.whitespace": "Remove the spaces or line breaks.",
  "publisher.nodeProfile.embedding.error.wildcard": "A wildcard must name a domain, such as https://*.example.org.",
  "publisher.nodeProfile.embedding.heading": "Embedding",
  "publisher.nodeProfile.embedding.intro": "Choose which other websites may show this node's globe in a frame, for example inside a WordPress post. The publisher portal never loads inside another site, whatever you choose here.",
  "publisher.nodeProfile.embedding.legend": "Who can embed this node",
  "publisher.nodeProfile.embedding.live.check": "Check again",
  "publisher.nodeProfile.embedding.live.checking": "Checking…",
  "publisher.nodeProfile.embedding.live.error": "Couldn't check what this node sends.",
  "publisher.nodeProfile.embedding.live.extra": "Another frame-ancestors policy also applies: {value}. It comes from an edge rule or public/_headers. Browsers enforce both, so the stricter one wins.",
  "publisher.nodeProfile.embedding.live.heading": "What this node sends now",
  "publisher.nodeProfile.embedding.live.notSent": "(not sent)",
  "publisher.nodeProfile.embedding.live.ok": "This matches the saved setting.",
  "publisher.nodeProfile.embedding.live.pending": "This doesn't match the saved setting yet. A change takes a few minutes to reach every server, so check again shortly.",
  "publisher.nodeProfile.embedding.live.xfo": "With \"Any site can embed\", this node sends no frame-ancestors, so browsers follow its X-Frame-Options: {value}. The header can block every other site. It often comes from the \"Add security headers\" managed transform in Cloudflare, or an edge rule. Turn it off there. If you can't, choose \"Only sites I list\": current browsers ignore X-Frame-Options once frame-ancestors is sent.",
  "publisher.nodeProfile.embedding.live.xfoIgnored": "Current browsers ignore this node's X-Frame-Options: {value}, because frame-ancestors is sent too. Only old browsers still follow the header, which often comes from the \"Add security headers\" managed transform in Cloudflare.",
  "publisher.nodeProfile.embedding.mode.any": "Any site can embed (default)",
  "publisher.nodeProfile.embedding.mode.any.desc": "No restriction. Every node starts here.",
  "publisher.nodeProfile.embedding.mode.list": "Only sites I list",
  "publisher.nodeProfile.embedding.mode.list.desc": "This node and the sites you list below. Other sites see a blocked frame.",
  "publisher.nodeProfile.embedding.mode.self": "No other site",
  "publisher.nodeProfile.embedding.mode.self.desc": "Only this node's own pages may show it in a frame.",
  "publisher.nodeProfile.embedding.origins.add": "Add a site",
  "publisher.nodeProfile.embedding.origins.file.how": "A page opened from a file has an address starting {scheme} and no site to list. To allow one, add a row with only {entry} in it. That is the word file followed by a colon, not {scheme} or a path.",
  "publisher.nodeProfile.embedding.origins.file.readOnly": "{entry} in this list lets any page opened from a file embed this node.",
  "publisher.nodeProfile.embedding.origins.file.risk": "Any page opened from a file can then embed this node, not only yours. Chrome, Edge and other Chromium browsers allow this. Test any other browser before you rely on it.",
  "publisher.nodeProfile.embedding.origins.file.summary": "Allow a page opened from a file",
  "publisher.nodeProfile.embedding.origins.hint": "One site per row: https:// and the host name, with no path or trailing slash. www.example.org and example.org are different sites, so add both if your pages use both. https://*.example.org covers its subdomains but not example.org itself.",
  "publisher.nodeProfile.embedding.origins.inputAria": "Site {n}",
  "publisher.nodeProfile.embedding.origins.label": "Sites allowed to embed",
  "publisher.nodeProfile.embedding.origins.max": "You can list up to {max} sites.",
  "publisher.nodeProfile.embedding.origins.removeAria": "Remove site {n}",
  "publisher.nodeProfile.embedding.presets.ai": "Claude and other AI apps show embeds through hosts they can change without notice, so a preset could stop working silently.",
  "publisher.nodeProfile.embedding.presets.social": "Facebook and most social feeds don't show a linked page in a frame. They show a preview card and open the link in a full page, so this setting doesn't affect sharing there.",
  "publisher.nodeProfile.embedding.presets.summary": "Why there are no presets for Facebook or Claude",
  "publisher.nodeProfile.embedding.presets.test": "To allow a site, try the embed on the real page first. Then list each origin around the embed: the page itself and any frame it sits in. Your browser's developer tools show them.",
  "publisher.nodeProfile.embedding.readOnly": "Only an admin can change who may embed this node.",
  "publisher.nodeProfile.embedding.save": "Save embedding",
  "publisher.nodeProfile.embedding.saved": "Embedding saved. It reaches visitors within a few minutes.",
  "publisher.nodeProfile.embedding.storedRefused": "Part of the saved setting is no longer accepted, so this node enforces only what is shown below, which is stricter. Check it and save again.",
  "publisher.nodeProfile.embedding.storedUnreadable": "The saved setting can't be read, so this node isn't limiting who embeds it. Choose a setting and save it again.",
  "publisher.nodeProfile.error.generic": "Couldn't save the profile. Try again.",
  "publisher.nodeProfile.error.orgName": "Organization name is required.",
  "publisher.nodeProfile.error.session": "Your session has expired — sign in again.",
  "publisher.nodeProfile.features.desc.analytics": "The analytics dashboard under Insights. The nightly usage rollup keeps archiving either way, so re-enabling leaves no gap.",
  "publisher.nodeProfile.features.desc.blog": "Blog authoring and the public /blog pages.",
  "publisher.nodeProfile.features.desc.datasets": "Dataset authoring: the Datasets and Import tabs and publishing. Published datasets stay visible in the catalog.",
  "publisher.nodeProfile.features.desc.events": "The current-events pipeline: feeds, the review queue, and the public events overlays and \"In the news\" panels.",
  "publisher.nodeProfile.features.desc.feedback": "The feedback review tab. While off, in-app feedback submissions are accepted but not stored.",
  "publisher.nodeProfile.features.desc.hero": "The \"Right now\" hero spotlight on the catalog landing surface.",
  "publisher.nodeProfile.features.desc.orbit": "Orbit, the chat assistant that uses generative AI to answer visitors' questions about datasets. While off, Orbit's chat and voice are removed from the public site and the desktop app. AI drafting in Blog and Events is unaffected.",
  "publisher.nodeProfile.features.desc.tours": "Tour authoring and the public tour cards in Browse.",
  "publisher.nodeProfile.features.desc.workflows": "Zyra data-pipeline workflows and their scheduler.",
  "publisher.nodeProfile.features.heading": "Features",
  "publisher.nodeProfile.features.intro": "Turn whole feature areas on or off for this node. Off means the tab is hidden, its API is gated, and its public surfaces go quiet. Changes reach visitors within a few minutes.",
  "publisher.nodeProfile.features.save": "Save features",
  "publisher.nodeProfile.features.saved": "Features saved. Public surfaces update within a few minutes.",
  "publisher.nodeProfile.intro": "The public identity of the organization hosting this node — shown on your catalog and blog.",
  "publisher.nodeProfile.links": "Links",
  "publisher.nodeProfile.links.add": "Add link",
  "publisher.nodeProfile.links.labelPlaceholder": "Label",
  "publisher.nodeProfile.links.removeAria": "Remove link",
  "publisher.nodeProfile.links.urlPlaceholder": "Link URL",
  "publisher.nodeProfile.loading": "Loading…",
  "publisher.nodeProfile.logo.alt": "Organization logo preview",
  "publisher.nodeProfile.logo.choose": "Choose image…",
  "publisher.nodeProfile.logo.error.size": "The logo must be at most 512 KB.",
  "publisher.nodeProfile.logo.error.type": "The logo must be a PNG, JPEG, or WebP image.",
  "publisher.nodeProfile.logo.hint": "PNG, JPEG, or WebP, up to 512 KB. Shown on the public blog.",
  "publisher.nodeProfile.logo.label": "Organization logo",
  "publisher.nodeProfile.logo.none": "No logo uploaded yet.",
  "publisher.nodeProfile.logo.remove": "Remove logo",
  "publisher.nodeProfile.logo.removed": "Logo removed.",
  "publisher.nodeProfile.logo.saveFirst": "Save the profile before uploading a logo.",
  "publisher.nodeProfile.logo.uploaded": "Logo updated.",
  "publisher.nodeProfile.logo.uploading": "Uploading…",
  "publisher.nodeProfile.mission": "Mission (one to three sentences)",
  "publisher.nodeProfile.orgName": "Organization name",
  "publisher.nodeProfile.regionFocus": "Geographic focus (optional)",
  "publisher.nodeProfile.regionFocus.hint": "Optional. The region your data centers on.",
  "publisher.nodeProfile.restricted": "Editing the node profile is restricted to admin publishers.",
  "publisher.nodeProfile.save": "Save profile",
  "publisher.nodeProfile.saved": "Profile saved.",
  "publisher.nodeProfile.section.missionAbout": "Mission & about",
  "publisher.nodeProfile.section.organization": "Organization",
  "publisher.nodeProfile.title": "Node profile",
  "publisher.overview.action.newDataset": "New dataset",
  "publisher.overview.action.newEvent": "New event",
  "publisher.overview.activity.empty": "No recent activity yet.",
  "publisher.overview.activity.eventsProposed.one": "{count} new event proposed",
  "publisher.overview.activity.eventsProposed.other": "{count} new events proposed",
  "publisher.overview.activity.feedback": "New feedback received",
  "publisher.overview.activity.feedbackDataset": "New feedback on “{dataset}”",
  "publisher.overview.activity.label": "Recent activity",
  "publisher.overview.activity.published": "Published “{title}”",
  "publisher.overview.activity.updated": "Updated “{title}”",
  "publisher.overview.activity.workflowFailed": "Workflow “{name}” failed",
  "publisher.overview.feedback.empty": "No feedback yet.",
  "publisher.overview.feedback.label": "Latest feedback",
  "publisher.overview.feedback.negative": "Negative rating",
  "publisher.overview.feedback.positive": "Positive rating",
  "publisher.overview.glance.aiSatisfaction": "AI satisfaction",
  "publisher.overview.glance.eventsSurfaced": "Events surfaced",
  "publisher.overview.glance.globeViews": "Globe views",
  "publisher.overview.glance.label": "At a glance · last 7 days",
  "publisher.overview.glance.publishedDatasets": "Published datasets",
  "publisher.overview.loading": "Loading overview…",
  "publisher.overview.needs.allClear": "You're all caught up — nothing needs review right now.",
  "publisher.overview.needs.events.action": "Review events",
  "publisher.overview.needs.events.detail": "From {source} · oldest {age}",
  "publisher.overview.needs.events.detailNoSource": "Oldest {age}",
  "publisher.overview.needs.events.title.one": "{count} event awaiting review",
  "publisher.overview.needs.events.title.other": "{count} events awaiting review",
  "publisher.overview.needs.hero.action": "Manage hero",
  "publisher.overview.needs.hero.title": "Hero expires {when}",
  "publisher.overview.needs.label": "Needs you",
  "publisher.overview.needs.workflow.action": "Inspect run",
  "publisher.overview.needs.workflow.detail": "{name} · {when}",
  "publisher.overview.needs.workflow.title": "Workflow failed",
  "publisher.overview.pipeline.caption": "From incoming feeds to the globe's front page — connecting what's happening in the news to the data that explains it.",
  "publisher.overview.pipeline.curate.kicker": "Curate + pair",
  "publisher.overview.pipeline.curate.stat.one": "{count} to review",
  "publisher.overview.pipeline.curate.stat.other": "{count} to review",
  "publisher.overview.pipeline.curate.sub.one": "{count} approved this week",
  "publisher.overview.pipeline.curate.sub.other": "{count} approved this week",
  "publisher.overview.pipeline.curate.title": "Events",
  "publisher.overview.pipeline.feature.kicker": "Feature",
  "publisher.overview.pipeline.feature.stat.live": "1 live",
  "publisher.overview.pipeline.feature.stat.none": "None set",
  "publisher.overview.pipeline.feature.sub": "expires {when}",
  "publisher.overview.pipeline.feature.subNone": "auto-derived hero",
  "publisher.overview.pipeline.feature.title": "Right now",
  "publisher.overview.pipeline.label": "Newsroom pipeline",
  "publisher.overview.pipeline.sources.kicker": "Sources",
  "publisher.overview.pipeline.sources.stat.one": "{count} active",
  "publisher.overview.pipeline.sources.stat.other": "{count} active",
  "publisher.overview.pipeline.sources.sub.one": "{count} new item today",
  "publisher.overview.pipeline.sources.sub.other": "{count} new items today",
  "publisher.overview.pipeline.sources.title": "Feeds",
  "publisher.overview.subtitle": "{org} · here's what needs you today.",
  "publisher.overview.subtitleNoOrg": "Here's what needs you today.",
  "publisher.overview.title": "Overview",
  "publisher.overview.viewAll": "View all",
  "publisher.placeholder.comingSoon": "This section ships in sub-phase {subPhase}.",
  "publisher.portal.title": "Publisher portal",
  "publisher.section.datasetDetail": "Dataset {id}",
  "publisher.section.datasets": "Datasets",
  "publisher.section.import": "Bulk import",
  "publisher.section.notFound": "Not found",
  "publisher.section.profile": "Profile",
  "publisher.section.tours": "Tours",
  "publisher.team.invite": "Invite member",
  "publisher.team.inviteNote": "Members are provisioned through your identity provider on first sign-in.",
  "publisher.team.roleGuide.cap.create": "Create drafts (datasets, events, blog, tours)",
  "publisher.team.roleGuide.cap.editAny": "Edit & publish anyone's content",
  "publisher.team.roleGuide.cap.editOwn": "Edit & delete their own content",
  "publisher.team.roleGuide.cap.hero": "Set the “Right now” hero",
  "publisher.team.roleGuide.cap.operator": "Manage feeds & node settings",
  "publisher.team.roleGuide.cap.publishOwn": "Publish & retract their own content",
  "publisher.team.roleGuide.cap.read": "Read the catalog, events & insights",
  "publisher.team.roleGuide.cap.users": "Manage members & roles",
  "publisher.team.roleGuide.capHeader": "Can",
  "publisher.team.roleGuide.intro": "Each role can do everything the ones before it can, plus more. Reading is open to every active member; roles differ in what they can create, publish, and administer.",
  "publisher.team.roleGuide.no": "No",
  "publisher.team.roleGuide.title": "What each role can do",
  "publisher.team.roleGuide.yes": "Yes",
  "publisher.team.rolesNote": "Admins manage the team, datasets, and settings. Editors publish and edit any content; authors create and publish their own; contributors draft content for review; reviewers have read-only access. Service keys ingest data through the API.",
  "publisher.team.serviceKey": "Service key",
  "publisher.team.subtitle": "Manage who can publish to your node, and the service keys that ingest data.",
  "publisher.team.title": "Team",
  "publisher.tours.action.delete": "Delete",
  "publisher.tours.action.delete.aria": "Delete tour {title}",
  "publisher.tours.action.edit": "Edit",
  "publisher.tours.action.retract": "Retract",
  "publisher.tours.action.retract.aria": "Retract published tour {title}",
  "publisher.tours.col.actions": "Actions",
  "publisher.tours.col.title": "Title",
  "publisher.tours.col.updated": "Updated",
  "publisher.tours.delete.confirm": "Delete tour \"{title}\"? This can't be undone.",
  "publisher.tours.empty.hint": "Camera positions, dataset loads, overlays, and narration steps can all be captured from the live globe.",
  "publisher.tours.empty.title": "No tours yet.",
  "publisher.tours.error": "Could not load tours — {detail}",
  "publisher.tours.filter.all": "All",
  "publisher.tours.filter.aria": "Filter tours by status",
  "publisher.tours.filter.draft": "Draft",
  "publisher.tours.filter.published": "Published",
  "publisher.tours.filter.retracted": "Retracted",
  "publisher.tours.heading": "Tours",
  "publisher.tours.intro": "Compose narrated sequences of camera positions and dataset loads. Click New tour to capture the first step.",
  "publisher.tours.loading": "Loading tours…",
  "publisher.tours.new": "+ New tour",
  "publisher.tours.new.aria": "Start a new tour",
  "publisher.tours.new.creating": "Creating draft…",
  "publisher.tours.retract.confirm": "Retract \"{title}\" from the public list? You can republish it later — the immutable snapshot stays in place.",
  "publisher.tours.status.draft": "Draft",
  "publisher.tours.status.published": "Published",
  "publisher.tours.status.retracted": "Retracted",
  "publisher.users.action.approve": "Approve",
  "publisher.users.action.failed": "Update failed",
  "publisher.users.action.reactivate": "Reactivate",
  "publisher.users.action.reject": "Reject",
  "publisher.users.action.suspend": "Suspend",
  "publisher.users.col.actions": "Actions",
  "publisher.users.col.role": "Role",
  "publisher.users.col.status": "Status",
  "publisher.users.col.user": "User",
  "publisher.users.confirm.reject": "Reject {name}'s account? They will not be able to publish until reactivated.",
  "publisher.users.confirm.suspend": "Suspend {name}'s account? They will lose access until reactivated.",
  "publisher.users.empty": "No users match this filter.",
  "publisher.users.filter.active": "Active",
  "publisher.users.filter.all": "All",
  "publisher.users.filter.pending": "Pending",
  "publisher.users.filter.suspended": "Suspended",
  "publisher.users.loading": "Loading users…",
  "publisher.users.restricted": "User administration is available to admins only.",
  "publisher.users.title": "Users",
  "publisher.workflows.action.edit": "Edit",
  "publisher.workflows.action.runNow": "Run now",
  "publisher.workflows.col.actions": "Actions",
  "publisher.workflows.col.enabled": "Enabled",
  "publisher.workflows.col.lastRun": "Last run",
  "publisher.workflows.col.name": "Name",
  "publisher.workflows.col.schedule": "Schedule",
  "publisher.workflows.col.target": "Target dataset",
  "publisher.workflows.detail.nextRun": "Next run",
  "publisher.workflows.empty.hint": "Create one to keep a real-time dataset updating itself on a schedule.",
  "publisher.workflows.empty.title": "No workflows yet.",
  "publisher.workflows.enabled.off": "Disabled",
  "publisher.workflows.enabled.on": "Enabled",
  "publisher.workflows.error": "Could not load workflows. Check your access and try again.",
  "publisher.workflows.form.back": "Back to workflows",
  "publisher.workflows.form.createTarget": "Create draft dataset",
  "publisher.workflows.form.createTarget.creating": "Creating…",
  "publisher.workflows.form.createTarget.done": "Draft created and linked.",
  "publisher.workflows.form.createTarget.failed": "Could not create the draft dataset.",
  "publisher.workflows.form.createTarget.needName": "Enter a workflow name first — it becomes the dataset title.",
  "publisher.workflows.form.description": "Description",
  "publisher.workflows.form.enabled": "Enabled — run on the schedule",
  "publisher.workflows.form.heading.edit": "Edit workflow",
  "publisher.workflows.form.heading.new": "New workflow",
  "publisher.workflows.form.insertStage": "Insert stage…",
  "publisher.workflows.form.name": "Name",
  "publisher.workflows.form.pipeline": "Zyra pipeline",
  "publisher.workflows.form.pipeline.hint": "YAML or JSON. Stages are checked against the server allowlist; at least one stage must write /work/output/dataset.mp4.",
  "publisher.workflows.form.pipelineParseError": "The pipeline is not valid YAML or JSON.",
  "publisher.workflows.form.save": "Save",
  "publisher.workflows.form.saving": "Saving…",
  "publisher.workflows.form.schedule": "Schedule",
  "publisher.workflows.form.schedule.hint": "ISO-8601 duration between PT15M and P90D — e.g. PT1H (hourly), P1D (daily), P1W (weekly).",
  "publisher.workflows.form.target": "Target dataset id",
  "publisher.workflows.form.target.hint": "The dataset this workflow overwrites in place each run. Create the draft dataset first, then paste its id here.",
  "publisher.workflows.form.template": "Metadata template",
  "publisher.workflows.form.template.applied": "Template applied — edit the source URL, pattern, and metadata before saving.",
  "publisher.workflows.form.template.hint": "JSON object of dataset fields. String values may use {{run_date}}, {{run_id}}, {{data_start}}, {{data_end}}, {{data_period}} — set start_time / end_time / period so real-time freshness works.",
  "publisher.workflows.form.template.overwriteConfirm": "Replace the current pipeline and metadata template with the selected template?",
  "publisher.workflows.form.templateParseError": "The metadata template is not valid JSON.",
  "publisher.workflows.form.templatePicker": "Start from a template…",
  "publisher.workflows.form.validate": "Validate",
  "publisher.workflows.form.validate.ok": "Pipeline and template look valid.",
  "publisher.workflows.heading": "Workflows",
  "publisher.workflows.intro": "Scheduled Zyra pipelines that keep real-time datasets fresh. Each workflow renders new data on a cadence and re-publishes its target dataset in place.",
  "publisher.workflows.lastRun.never": "Never",
  "publisher.workflows.loading": "Loading workflows…",
  "publisher.workflows.new": "New workflow",
  "publisher.workflows.run.failed": "Couldn't run",
  "publisher.workflows.run.queued": "Queued ✓",
  "publisher.workflows.runNow": "Run now",
  "publisher.workflows.runNow.failed": "Could not queue the run.",
  "publisher.workflows.runNow.inProgress": "A run is already in progress.",
  "publisher.workflows.runNow.queued": "Run queued.",
  "publisher.workflows.runStatus.canceled": "Canceled",
  "publisher.workflows.runStatus.failed": "Failed",
  "publisher.workflows.runStatus.queued": "Queued",
  "publisher.workflows.runStatus.running": "Running",
  "publisher.workflows.runStatus.success": "Success",
  "publisher.workflows.runs.col.created": "Queued",
  "publisher.workflows.runs.col.detail": "Detail",
  "publisher.workflows.runs.col.finished": "Finished",
  "publisher.workflows.runs.col.status": "Status",
  "publisher.workflows.runs.col.trigger": "Trigger",
  "publisher.workflows.runs.empty": "No runs yet.",
  "publisher.workflows.runs.heading": "Run history",
  "publisher.workflows.runs.log": "Actions log",
  "publisher.workflows.runs.status.canceled": "Canceled",
  "publisher.workflows.runs.status.failed": "Failed",
  "publisher.workflows.runs.status.queued": "Queued",
  "publisher.workflows.runs.status.running": "Running",
  "publisher.workflows.runs.status.succeeded": "Succeeded",
  "publisher.workflows.runs.trigger.manual": "Manual",
  "publisher.workflows.runs.trigger.schedule": "Scheduled",
  "publisher.workflows.template.ftpFrames": "FTP frames → SOS MP4 (NOAA weekly drought)",
  "publisher.workflows.template.gefsCycle": "Model cycle → SOS MP4 (NOAA GEFS forecast)",
  "publisher.workflows.template.httpFrames": "HTTP frames → SOS MP4",
  "tools.actions.analyze": "Analyze…",
  "tools.actions.clear": "Clear markers & highlights",
  "tools.actions.credits": "Credits…",
  "tools.actions.meetOrbit": "Meet Orbit →",
  "tools.actions.orbitSettings": "Orbit settings…",
  "tools.actions.outputs": "Outputs…",
  "tools.actions.playlists": "Playlist manager…",
  "tools.actions.privacy": "Privacy settings…",
  "tools.actions.share": "Share dataset…",
  "tools.announce.analyzeOpened": "Analysis panel opened",
  "tools.announce.autoRotate.off": "Auto-rotation disabled",
  "tools.announce.autoRotate.on": "Auto-rotation enabled",
  "tools.announce.borders.off": "Borders off",
  "tools.announce.borders.on": "Borders on",
  "tools.announce.cleared": "Markers and highlights cleared",
  "tools.announce.creditsOpened": "Credits opened",
  "tools.announce.datasetInfo.off": "Dataset info hidden",
  "tools.announce.datasetInfo.on": "Dataset info shown",
  "tools.announce.labels.off": "Labels off",
  "tools.announce.labels.on": "Labels on",
  "tools.announce.layout": "Layout: {label}",
  "tools.announce.legend.off": "Legend hidden",
  "tools.announce.legend.on": "Legend shown",
  "tools.announce.meetOrbit": "Opening Orbit character page in new tab",
  "tools.announce.noDatasetToShare": "No dataset loaded to share",
  "tools.announce.outputsOpened": "Outputs panel opened",
  "tools.announce.privacyOpened": "Privacy settings opened",
  "tools.announce.shared": "Dataset shared",
  "tools.announce.terrain.off": "3D terrain off",
  "tools.announce.terrain.on": "3D terrain on",
  "tools.browse.aria": "Browse datasets",
  "tools.browse.label": "Browse",
  "tools.close.aria": "Close tools",
  "tools.language.aria": "Choose language",
  "tools.layout.aria": "Globe layout",
  "tools.layout.four": "Four globes in a grid",
  "tools.layout.four.unavailable": "Four globes need a larger screen",
  "tools.layout.single": "Single globe",
  "tools.layout.twoHorizontal": "Two globes side-by-side",
  "tools.layout.twoVertical": "Two globes stacked",
  "tools.menu.aria": "Tools and settings",
  "tools.popover.title": "Tools",
  "tools.section.about": "About",
  "tools.section.about.aria": "About",
  "tools.section.actions": "Actions",
  "tools.section.actions.aria": "Actions",
  "tools.section.language": "Language",
  "tools.section.language.aria": "Language",
  "tools.section.layout": "Layout",
  "tools.section.layout.aria": "Layout",
  "tools.section.orbit": "Orbit",
  "tools.section.orbit.aria": "Orbit",
  "tools.section.outputs": "Outputs",
  "tools.section.outputs.aria": "Multi-monitor outputs",
  "tools.section.playlists": "Playlists",
  "tools.section.playlists.aria": "Playlists",
  "tools.section.view": "View",
  "tools.section.view.aria": "View toggles",
  "tools.share.text": "Check out \"{title}\" on Terraviz",
  "tools.specular.announce": "Sun glint: {label}",
  "tools.specular.aria": "Sun glint over water",
  "tools.specular.comfortable": "Comfortable",
  "tools.specular.default": "Default",
  "tools.specular.none": "None",
  "tools.specular.section": "Sun glint",
  "tools.specular.section.aria": "Sun glint over water",
  "tools.toggle.aria": "Tools and settings",
  "tools.toggles.autoRotate": "Auto-rotate",
  "tools.toggles.borders": "Borders",
  "tools.toggles.datasetInfo": "Dataset info",
  "tools.toggles.labels": "Labels",
  "tools.toggles.legend": "Legend",
  "tools.toggles.terrain": "3D terrain",
  "tools.uiScale.announce": "UI size: {label}",
  "tools.uiScale.aria": "UI size",
  "tools.uiScale.comfortable": "Comfortable",
  "tools.uiScale.compact": "Compact",
  "tools.uiScale.default": "Default",
  "tools.uiScale.section": "Display",
  "tools.uiScale.section.aria": "Display size",
  "tour.close": "Close",
  "tour.controls.continue.aria": "Continue tour",
  "tour.controls.pause.aria": "Pause tour",
  "tour.dock.action.captureCamera": "+ Add camera step",
  "tour.dock.action.captureDataset": "+ Add current dataset",
  "tour.dock.action.captureTilt": "+ Add tilt / rotate",
  "tour.dock.action.resetAndZoom": "+ Reset + zoom out",
  "tour.dock.action.resetZoom": "+ Reset zoom",
  "tour.dock.aria": "Tour authoring dock",
  "tour.dock.autosave.error": "Save failed",
  "tour.dock.autosave.idle": "Not saved",
  "tour.dock.autosave.saved": "Saved",
  "tour.dock.autosave.saving": "Saving…",
  "tour.dock.description.aria": "Tour description",
  "tour.dock.description.placeholder": "Describe what this tour shows",
  "tour.dock.discard.aria": "Discard and return to tour list",
  "tour.dock.env.off": "off",
  "tour.dock.env.on": "on",
  "tour.dock.group.env": "Environment",
  "tour.dock.group.flow": "Flow control",
  "tour.dock.group.layout": "Layout",
  "tour.dock.group.media": "Media",
  "tour.dock.group.player": "Tour player chrome",
  "tour.dock.group.rotation": "Rotation rate (deg/sec)",
  "tour.dock.layout.1": "1 globe",
  "tour.dock.layout.2": "2 globes",
  "tour.dock.layout.4": "4 globes",
  "tour.dock.loop.add": "+ Loop to start",
  "tour.dock.media.addEmbed": "Add embed",
  "tour.dock.media.addImage": "Add image",
  "tour.dock.media.addVideo": "Add video",
  "tour.dock.media.caption.placeholder": "Caption (optional)",
  "tour.dock.media.error.embedUrl": "Enter a page or video URL. YouTube and Vimeo links are converted to their embeddable player automatically.",
  "tour.dock.media.error.generic": "Media upload failed. Try again.",
  "tour.dock.media.error.noVisible": "No media is currently shown.",
  "tour.dock.media.error.size": "Upload must be at most 4 MB.",
  "tour.dock.media.error.type": "Upload must be a PNG, JPEG, or WebP image.",
  "tour.dock.media.error.url": "Enter an http(s) media URL first.",
  "tour.dock.media.hideLatest": "Hide latest media",
  "tour.dock.media.upload": "Upload image…",
  "tour.dock.media.uploading": "Uploading…",
  "tour.dock.media.url.aria": "Image or video URL",
  "tour.dock.pause.input.add": "+ Pause for input",
  "tour.dock.pause.seconds.add": "+ Pause",
  "tour.dock.pause.seconds.aria": "Pause duration in seconds",
  "tour.dock.player.enable": "Enable tour player",
  "tour.dock.player.window": "Tour player window",
  "tour.dock.preview.aria": "Play the current draft on the globe (preview without publishing)",
  "tour.dock.preview.empty.aria": "Capture at least one step before previewing",
  "tour.dock.preview.label": "Preview",
  "tour.dock.publish.aria": "Publish the current draft as the live tour",
  "tour.dock.publish.error": "Publish failed",
  "tour.dock.publish.idle": "Publish",
  "tour.dock.publish.published": "Published ✓",
  "tour.dock.publish.publishing": "Publishing…",
  "tour.dock.rotation.add": "+ Add",
  "tour.dock.rotation.input.aria": "Globe rotation rate in degrees per second",
  "tour.dock.task.delete.aria": "Delete task {n}",
  "tour.dock.task.edit.aria": "Edit task {n}",
  "tour.dock.task.editor.aria": "JSON editor for task {n}",
  "tour.dock.task.editor.cancel": "Cancel",
  "tour.dock.task.editor.error.json": "Invalid JSON: {detail}",
  "tour.dock.task.editor.error.shape": "Must be a JSON object with exactly one task key (e.g. {\"flyTo\": {...}}).",
  "tour.dock.task.editor.save": "Save",
  "tour.dock.taskList.aria": "Captured tour tasks",
  "tour.dock.taskList.empty": "No tasks captured yet. Use the buttons above to add a step.",
  "tour.dock.title": "Tour authoring",
  "tour.dock.titleInput.aria": "Tour title",
  "tour.dock.titleInput.placeholder": "Untitled tour",
  "tour.dock.titleInput.save.error": "Couldn't save title: {detail}",
  "tour.dock.unload.handle.add": "+ Unload by handle",
  "tour.dock.unload.handle.aria": "Pick a loaded-dataset handle to unload",
  "tour.dock.unloadAll.add": "+ Unload all datasets",
  "tour.dock.visibility.aria": "Tour visibility",
  "tour.dock.visibility.federated": "Federated (peers only)",
  "tour.dock.visibility.label": "Visibility",
  "tour.dock.visibility.private": "Private (only you)",
  "tour.dock.visibility.public": "Public (anyone)",
  "tour.dock.visibility.restricted": "Restricted (signed-in viewers)",
  "tour.image.alt": "Tour image",
  "tour.legend.alt": "Legend",
  "tour.next.aria": "Next section",
  "tour.play.aria": "Play tour",
  "tour.previous.aria": "Previous section",
  "tour.question.alt": "Question",
  "tour.question.answer.alt": "Answer",
  "tour.question.answer.aria": "Answer {n}",
  "tour.question.continue": "Continue",
  "tour.question.loading": "Loading question…",
  "tour.stop.aria": "Stop tour",
  "tour.task.env.borders": "Borders → {state}",
  "tour.task.env.clouds": "Clouds → {state}",
  "tour.task.env.dayNight": "Day/night → {state}",
  "tour.task.env.earth": "Earth → {state}",
  "tour.task.env.stars": "Stars → {state}",
  "tour.task.flyTo.summary": "Camera → {lat}, {lon} at {altmi} mi",
  "tour.task.loadDataset.summary": "Load dataset → {id}",
  "tour.task.loop": "Loop to beginning",
  "tour.task.pause.input": "Pause for input",
  "tour.task.pause.seconds": "Pause {seconds} sec",
  "tour.task.player.enable": "Tour player → {state}",
  "tour.task.player.window": "Player window → {state}",
  "tour.task.resetAndZoom": "Reset camera + zoom",
  "tour.task.resetZoom": "Reset zoom",
  "tour.task.rotation.summary": "Rotation rate → {rate} deg/sec",
  "tour.task.setEnvView.summary": "Layout → {view}",
  "tour.task.tiltRotate.summary": "Tilt {tilt}° / rotate {rotate}°",
  "tour.task.unload.handle": "Unload dataset → {handle}",
  "tour.task.unloadAll": "Unload all datasets",
  "tour.toolbar.aria": "Tour controls",
  "viewport.panel.displayLost": "Graphics reset — reload to restore",
  "viewport.panel.streamFailed": "Stopped updating",
  "viewport.panel.timeMismatch": "Showing {date}",
  "vr.controllerTooltip.grip": "Grip: exit",
  "vr.controllerTooltip.thumbstick": "Thumbstick: zoom",
  "vr.controllerTooltip.trigger": "Trigger: rotate",
  "vr.enter.ar.label": "Enter AR",
  "vr.enter.ar.title": "Enter passthrough AR mode (globe appears in your room)",
  "vr.enter.aria": "Enter immersive VR mode",
  "vr.enter.label": "Enter VR",
  "vr.enter.title": "Enter immersive VR mode",
  "vr.error.failed": "Failed to enter {mode}",
  "vr.hud.dataNotLoaded": "Data not loaded",
  "vr.loading.failed": "Couldn't load the dataset",
  "vr.loading.ready": "Ready",
  "vr.loading.timedOut": "Dataset is taking too long",
  "vr.zoomSlider.aria": "Zoom the globe",
  "vr.zoomSlider.label": "Zoom",
  "vr.zoomSlider.title": "Drag to zoom in or out",
  "zip.action.cancel": "Cancel",
  "zip.action.start": "Start download",
  "zip.action.zipDownload": "Download as .zip",
  "zip.action.zipDownload.aria": "Download {title} as a zip archive",
  "zip.action.zipDownload.title": "Download this dataset as a .zip archive",
  "zip.asset.caption": "Captions",
  "zip.asset.colorTable": "Color table",
  "zip.asset.frames": "Source frames ({count})",
  "zip.asset.legend": "Legend",
  "zip.asset.manifest": "manifest.json",
  "zip.asset.primary": "Primary data",
  "zip.asset.thumbnail": "Thumbnail",
  "zip.assets.aria": "Assets to include in the archive",
  "zip.cancelled.announce": "Zip download cancelled.",
  "zip.completed.announce": "Saved {filename} ({size}).",
  "zip.completed.withFailures.announce": "Saved {filename} ({size}); {count} asset(s) failed and were recorded in manifest.json.",
  "zip.dialog.close.aria": "Close download dialog",
  "zip.dialog.loading": "Resolving assets…",
  "zip.dialog.title": "Download dataset",
  "zip.error.datasetMissing": "Dataset is no longer available.",
  "zip.error.downloadFailed": "Download failed: {reason}",
  "zip.progress.done": "Finished.",
  "zip.progress.fetching": "Fetching assets…",
  "zip.progress.fetchingNamed": "Fetching {file}…",
  "zip.progress.packaging": "Packaging into zip…",
  "zip.progress.starting": "Starting…",
  "zip.size.alwaysIncluded": "always included",
  "zip.size.approxPrefix": "≈",
  "zip.size.estimating": "Estimating size…",
  "zip.size.overCap": "This archive would exceed the {cap} cap. Uncheck some assets to reduce the size.",
  "zip.size.overWarn": "This archive is larger than {warn}. Browser tabs can run out of memory on multi-GB downloads.",
  "zip.size.total": "Estimated total: {size}",
  "zip.size.unknown": "size unknown",
  "zip.source.external": "Asset hosted externally; see manifest for source URLs.",
  "zip.source.publisher": "Downloaded as source data from the publisher upload.",
  "zip.source.sos": "Downloaded from the legacy SOS catalog (sos.noaa.gov).",
  "zip.source.vimeo": "HLS adaptive video; downloaded as the best-quality MP4 from the Vimeo proxy.",
} as const

export const enMessages: Readonly<Record<string, string>> = enLiteral

/**
 * Literal-key union when entries exist; widens to `string` while
 * `en.json` is empty so callers aren't blocked.
 */
export type MessageKey = keyof typeof enLiteral extends never
  ? string
  : keyof typeof enLiteral

/** Lazy loaders, one per locale. English resolves synchronously. */
export const localeLoaders: Readonly<
  Record<Locale, () => Promise<Readonly<Record<string, string>>>>
> = {
  "ar": () => import('./messages.ar').then((m) => m.default),
  "en": async () => enMessages,
  "es": () => import('./messages.es').then((m) => m.default),
  "et": () => import('./messages.et').then((m) => m.default),
  "kab": () => import('./messages.kab').then((m) => m.default),
}
